function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import "jquery.cookie";
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Api from "../ajax/SessionApi";
import * as Utility from "../commons/Utility";
import { ReductionStatuses } from "../enum/ReductionStatuses";
import * as MemberModalComponent from "./SessionMemberModalComponent";
import * as SessionModalComponent from "./SessionModalComponent";
import * as SessionCopyModalComponent from "./SessionCopyModalComponent";
import * as SessionSceneModalComponent from "./SessionSceneModalComponent";
import * as TerrainModelingModalComponent from "./TerrainModelingModalComponent";
import * as SessionPortalModalComponent from "./SessionPortalModalComponent";
import * as SessionStreamingModalComponent from "./SessionStreamingModalComponent";
import * as SessionStreamingSettingModalComponent from "./SessionStreamingSettingModalComponent";
import * as SessionActionsHistoryModalComponent from "./SessionActionsHistoryModalComponent";
import * as SessionAuthoringMenuModalComponent from "./SessionAuthoringMenuModalComponent";
import * as SessionAuthoringModalComponent from "./SessionAuthoringModalComponent";
import * as SessionAuthoringEmptyModalComponent from "./SessionAuthoringEmptyModalComponent";
import * as SessionAuthoringTextPanelModalComponent from "./SessionAuthoringTextPanelModalComponent";
import * as SessionAuthoringMessageModalComponent from "./SessionAuthoringMessageModalComponent";
import * as SessionAuthoringEffectModalComponent from "./SessionAuthoringEffectModalComponent";
import * as SessionAuthoringDataPanelModalComponent from "./SessionAuthoringDataPanelModalComponent";
import * as SessionOffsetModalComponent from "./SessionOffsetModalComponent";
import * as QrCodeModalComponent from "./SessionQrCodeModalComponent";
import * as SessionGroupMaterialModalComponent from "./SessionGroupMaterialModalComponent";
import { ApiResultCodes } from "../enum/ApiResultCodes";
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import streamSaver from 'streamsaver';
import IntlMessage from '../commons/Intl';
import { Sessions, ResourceUpload, Terrain, Errors, Label, Session, Situations, Action, Portal, Streaming, StreamingSituations, Description, ReductionRate, PlaybackMode } from '../commons/IntlMessages';
import { ShareActionTypes } from "../enum/ShareActionTypes";
import { StreamingStatuses } from "../enum/StreamingStatuses";
import SessionMaterialInstanceModel from "../models/session/SessionMaterialInstanceModel";
import SessionMaterialStateInstanceModel from "../models/session/SessionMaterialStateInstanceModel";
import UploadGroupMaterialsInstanceModel from "../models/session/UploadGroupMaterialsInstanceModel";
import UploadGroupMaterialsItemInstanceModel from "../models/session/UploadGroupMaterialsItemInstanceModel";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language);
var effects = ["Fire1", "Fire2", "Fire3", "Fire4", "Smoke", "Smoke2"];
/**
 * 素材リスト
 */

var materialFileList = [];
/**
 * 素材サイズの合計
 */

var totalMaterialFileSize;
/**
 * アバターサイズの合計
 */

var totalAvatarFileSize;
/**
 * メインコンポーネント
 */

var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    var strOpenNavSessionIds = $.cookie("OpenNavSessionIds");
    _this.openNavSessionIds = strOpenNavSessionIds == null ? [] : JSON.parse(strOpenNavSessionIds);
    _this.state = {
      QueryIntervalId: 0,
      MyExpanded: false,
      ShareExpanded: false,
      OthersExpanded: false,
      ShareExpandedOwners: [],
      OthersExpandedOwners: [],
      SearchWord: null,
      IncludePastMeetings: false,
      IsFilter: false,
      IsProcessing: false,
      Sessions: null,
      SessionModalMode: SessionModalComponent.Mode.None,
      SessionCopyModalMode: SessionCopyModalComponent.Mode.None,
      SavedSessionModalMode: SessionModalComponent.Mode.None,
      SavedSessionCopyModalMode: SessionCopyModalComponent.Mode.None,
      SessionSceneModalMode: SessionSceneModalComponent.Mode.None,
      MemberModalMode: MemberModalComponent.Mode.None,
      TerrainModelingModalMode: TerrainModelingModalComponent.Mode.None,
      PortalModalMode: SessionPortalModalComponent.Mode.None,
      SessionStreamingModalMode: SessionStreamingModalComponent.Mode.None,
      SessionStreamingSettingModalMode: SessionStreamingSettingModalComponent.Mode.None,
      SessionActionsHistoryModalMode: SessionActionsHistoryModalComponent.Mode.None,
      SessionAuthoringMenuModalMode: SessionAuthoringMenuModalComponent.Mode.None,
      SessionAuthoringModalMode: SessionAuthoringModalComponent.Mode.None,
      SessionAuthoringModalAuthoringMode: SessionAuthoringModalComponent.AuthoringMode.Interactions,
      SessionAuthoringEmptyModalMode: SessionAuthoringEmptyModalComponent.Mode.None,
      SessionAuthoringEffectModalMode: SessionAuthoringEffectModalComponent.Mode.None,
      SessionAuthoringTextPanelModalMode: SessionAuthoringTextPanelModalComponent.Mode.None,
      SessionAuthoringMessageModalMode: SessionAuthoringMessageModalComponent.Mode.None,
      SessionAuthoringDataPanelModalMode: SessionAuthoringDataPanelModalComponent.Mode.None,
      SessionOffsetModalMode: SessionOffsetModalComponent.Mode.None,
      QrCodeModalMode: QrCodeModalComponent.Mode.None,
      SessionGroupMaterialModalMode: SessionGroupMaterialModalComponent.Mode.None,
      Selected: null,
      TargetFolderName: null,
      ModifiedSessionId: null,
      ModifiedSessionName: null,
      ModifiedStartDate: null,
      ModifiedStartTimeHours: null,
      ModifiedStartTimeMinutes: null,
      ModifiedEndDate: null,
      ModifiedEndTimeHours: null,
      ModifiedEndTimeMinutes: null,
      ModifiedSpecifyPeriod: null,
      ModifiedUseState: null,
      ModifiedUseMember: null,
      ModifiedScene: null,
      MonthlyTotalUpTime: 0,
      MonthlyLimitUpTime: 0,
      UploadingFiles: {},
      IsDownloading: false,
      ErrorMessages: []
    };

    _this.clearTempValue();

    if (_this.props.mode > 0) {
      if (_this.props.mode == 1) {
        Api.Query(false, function (data) {
          _this.clearTempValue();

          _this.setState({
            SessionModalMode: SessionModalComponent.Mode.Add,
            Sessions: data.Sessions,
            MyExpanded: data.Sessions.MyExpanded,
            ShareExpanded: data.Sessions.ShareExpanded,
            OthersExpanded: data.Sessions.OthersExpanded,
            SearchWord: data.Sessions.FilteringWord,
            IncludePastMeetings: data.Sessions.IncludePastMeetings,
            QueryIntervalId: window.setInterval(_this.query.bind(_assertThisInitialized(_this)), _this.props.queryRefreshInterval)
          });

          _this.updateStreamMessage(data);
        });
      } else {
        Api.QueryDetail(_this.props.sessionId, false, function (data) {
          _this.updateTempValue(data.Detail);

          _this.setState({
            Sessions: data.Sessions,
            MyExpanded: data.Sessions.MyExpanded,
            ShareExpanded: data.Sessions.ShareExpanded,
            OthersExpanded: data.Sessions.OthersExpanded,
            SearchWord: data.Sessions.FilteringWord,
            IncludePastMeetings: data.Sessions.IncludePastMeetings,
            Selected: {
              SessionId: _this.props.sessionId,
              Detail: data.Detail,
              IsAllSelected: false,
              SelectedFileName: null,
              SelectedFileNames: [],
              StreamingLocation: null,
              StreamingStatus: null,
              StreamingUrl: null,
              SelectedGroupMaterial: null,
              SelectedOriginalReductionRate: 0,
              SelectedChangedReductionRate: 0,
              SelectedOriginalPlaybackMode: 0,
              SelectedChangedPlaybackMode: 0,
              IsMyMeeting: data.Detail.IsMyMeeting,
              IsOthersMeeting: data.Detail.IsOthersMeeting,
              IsOver: data.Detail.IsHistory,
              IsHistory: false
            },
            QueryIntervalId: window.setInterval(_this.query.bind(_assertThisInitialized(_this)), _this.props.queryRefreshInterval)
          });

          _this.updateStreamMessage(data);
        });
      }
    } else if (_this.props.sessionId < 0) {
      Api.Query(false, function (data) {
        _this.clearTempValue();

        _this.setState({
          Sessions: data.Sessions,
          MyExpanded: data.Sessions.MyExpanded,
          ShareExpanded: data.Sessions.ShareExpanded,
          OthersExpanded: data.Sessions.OthersExpanded,
          SearchWord: data.Sessions.FilteringWord,
          IncludePastMeetings: data.Sessions.IncludePastMeetings,
          QueryIntervalId: window.setInterval(_this.query.bind(_assertThisInitialized(_this)), _this.props.queryRefreshInterval)
        });

        _this.updateStreamMessage(data);
      });
    } else {
      Api.QueryDetail(_this.props.sessionId, false, function (data) {
        _this.updateTempValue(data.Detail);

        _this.setState({
          Sessions: data.Sessions,
          MyExpanded: data.Sessions.MyExpanded,
          ShareExpanded: data.Sessions.ShareExpanded,
          OthersExpanded: data.Sessions.OthersExpanded,
          SearchWord: data.Sessions.FilteringWord,
          IncludePastMeetings: data.Sessions.IncludePastMeetings,
          Selected: {
            SessionId: _this.props.sessionId,
            Detail: data.Detail,
            IsAllSelected: false,
            SelectedFileName: null,
            SelectedFileNames: [],
            StreamingLocation: null,
            StreamingStatus: null,
            StreamingUrl: null,
            SelectedGroupMaterial: null,
            SelectedOriginalReductionRate: 0,
            SelectedChangedReductionRate: 0,
            SelectedOriginalPlaybackMode: 0,
            SelectedChangedPlaybackMode: 0,
            IsMyMeeting: data.Detail.IsMyMeeting,
            IsOthersMeeting: data.Detail.IsOthersMeeting,
            IsOver: data.Detail.IsHistory,
            IsHistory: true
          },
          QueryIntervalId: window.setInterval(_this.query.bind(_assertThisInitialized(_this)), _this.props.queryRefreshInterval)
        });

        _this.updateStreamMessage(data);
      });
    }

    _this.handleAddFiles = _this.handleAddFiles.bind(_assertThisInitialized(_this));
    _this.handleUploadDone = _this.handleUploadDone.bind(_assertThisInitialized(_this));
    _this.handleUploadFail = _this.handleUploadFail.bind(_assertThisInitialized(_this));
    _this.handleUploadProgress = _this.handleUploadProgress.bind(_assertThisInitialized(_this));
    _this.beforeunloadFunction = _this.beforeunload.bind(_assertThisInitialized(_this));
    _this.isSubmit = false;
    return _this;
  }
  /**
   * ページアンロードイベント
   */


  _createClass(MainComponent, [{
    key: "beforeunload",
    value: function beforeunload(event) {
      var uploading = false;
      var confirmNavigationWarning = intl.format(Description.ConfirmNavigationWarning);

      if (this.props.useLargeCapacityOption) {
        if (this.state.Sessions != null) {
          for (var i = 0; i < this.state.Sessions.MyMeetingList.length; i++) {
            var session = this.state.Sessions.MyMeetingList[i];
            var sessionFiles = this.state.UploadingFiles[session.SessionId];

            if (sessionFiles) {
              if (Object.keys(sessionFiles).length > 0) {
                uploading = true;
              }
            }
          }

          for (var i = 0; i < this.state.Sessions.ShareMeetingList.length; i++) {
            var owners = this.state.Sessions.ShareMeetingList[i];

            for (var j = 0; j < owners.MeetingList.length; j++) {
              var _session = owners.MeetingList[j];
              var _sessionFiles = this.state.UploadingFiles[_session.SessionId];

              if (_sessionFiles) {
                if (Object.keys(_sessionFiles).length > 0) {
                  uploading = true;
                }
              }
            }
          }

          for (var i = 0; i < this.state.Sessions.OthersMeetingList.length; i++) {
            var _owners = this.state.Sessions.OthersMeetingList[i];

            for (var j = 0; j < _owners.MeetingList.length; j++) {
              var _session2 = _owners.MeetingList[j];
              var _sessionFiles2 = this.state.UploadingFiles[_session2.SessionId];

              if (_sessionFiles2) {
                if (Object.keys(_sessionFiles2).length > 0) {
                  uploading = true;
                }
              }
            }
          }
        }
      }

      if (uploading) {
        (event || window.event).returnValue = confirmNavigationWarning;
        return confirmNavigationWarning;
      } else {
        return '';
      }
    }
  }, {
    key: "updateStreamMessage",
    value: function updateStreamMessage(data) {
      if (data && data.Sessions && data.Sessions.UseStreamingOption) {
        this.setState({
          MonthlyTotalUpTime: data.Sessions.MonthlyTotalUpTime,
          MonthlyLimitUpTime: data.Sessions.MonthlyLimitUpTime
        });
      }
    }
  }, {
    key: "clearTempValue",
    value: function clearTempValue() {
      materialFileList = [];
      totalMaterialFileSize = 0;
      totalAvatarFileSize = 0;
    }
  }, {
    key: "updateTempValue",
    value: function updateTempValue(detail) {
      if (!detail) return;
      materialFileList = detail.MaterialList.map(function (m) {
        return m.MaterialFileName;
      });
      totalMaterialFileSize = 0;

      for (var i = 0; i < detail.MaterialList.length; i++) {
        var material = detail.MaterialList[i];
        totalMaterialFileSize = totalMaterialFileSize + material.MaterialFileSize * 1024;
      }

      totalAvatarFileSize = detail.TargetCount * this.props.AvatarStorageSize * 1024 * 1024;
    }
    /**
     * 検索を行います。
     */

  }, {
    key: "query",
    value: function query() {
      var _this2 = this;

      if (this.state.Selected == null) {
        if (this.state.IsProcessing) return;
        Api.Query(true, function (data) {
          if (_this2.state.IsProcessing) return;

          _this2.clearTempValue();

          _this2.setState({
            Sessions: data.Sessions
          });

          _this2.updateStreamMessage(data);
        });
      } else {
        Api.QueryDetail(this.state.Selected.SessionId, true, function (data) {
          if (_this2.state.IsProcessing) return;
          if (_this2.state.Selected == null || _this2.state.Selected.SessionId != data.Detail.SessionId) return;

          if (_this2.state.Selected != null && !_this2.state.Selected.IsHistory) {
            var saveIsAllSelected = _this2.state.Selected.IsAllSelected;
            var saveSelectedFileName = _this2.state.Selected.SelectedFileNames;
            var isHistory = _this2.state.Selected.IsHistory;

            _this2.updateTempValue(data.Detail);

            _this2.setState({
              Sessions: data.Sessions,
              Selected: {
                SessionId: data.Detail.SessionId,
                Detail: data.Detail,
                IsAllSelected: saveIsAllSelected,
                SelectedFileName: null,
                SelectedFileNames: [],
                StreamingLocation: null,
                StreamingStatus: null,
                StreamingUrl: null,
                SelectedGroupMaterial: null,
                SelectedOriginalReductionRate: 0,
                SelectedChangedReductionRate: 0,
                SelectedOriginalPlaybackMode: 0,
                SelectedChangedPlaybackMode: 0,
                IsMyMeeting: data.Detail.IsMyMeeting,
                IsOthersMeeting: data.Detail.IsOthersMeeting,
                IsOver: data.Detail.IsHistory,
                IsHistory: isHistory
              }
            });

            for (var i = 0; i < data.Detail.MaterialList.length; i++) {
              var item = data.Detail.MaterialList[i];
              var checked = saveSelectedFileName.filter(function (x, _i) {
                return x == item.MaterialFileName;
              });

              if (checked.length > 0 && item.Status != ReductionStatuses.Wait && item.Status != ReductionStatuses.Processing) {
                _this2.changeSelectedMaterial(item);
              }

              var allUploadingFiles = _objectSpread({}, _this2.state.UploadingFiles);

              if (allUploadingFiles != null) {
                var _allUploadingFiles$da;

                var uploadingFiles = (_allUploadingFiles$da = _objectSpread({}, allUploadingFiles[data.Detail.SessionId])) !== null && _allUploadingFiles$da !== void 0 ? _allUploadingFiles$da : {};

                if (uploadingFiles[item.MaterialFileName] != null) {
                  delete uploadingFiles[item.MaterialFileName];
                }

                allUploadingFiles[data.Detail.SessionId] = uploadingFiles;

                _this2.setState({
                  UploadingFiles: allUploadingFiles
                });
              }
            }

            _this2.updateStreamMessage(data);
          }
        });
      }
    }
    /**
     * 会議を選択します。
     *
     * @param session 会議情報
     * @param isMyMeeting My Meetingかどうかを表す値
     * @param isOthersMeeting Others Meetingかどうかを表す値
     */

  }, {
    key: "selectSession",
    value: function selectSession(session, isMyMeeting, isOthersMeeting) {
      var _this3 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.QueryDetail(session.SessionId, false, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        _this3.updateTempValue(data.Detail);

        _this3.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: {
            SessionId: session.SessionId,
            Detail: data.Detail,
            IsAllSelected: false,
            SelectedFileName: null,
            SelectedFileNames: [],
            StreamingLocation: null,
            StreamingStatus: null,
            StreamingUrl: null,
            SelectedGroupMaterial: null,
            SelectedOriginalReductionRate: 0,
            SelectedChangedReductionRate: 0,
            SelectedOriginalPlaybackMode: 0,
            SelectedChangedPlaybackMode: 0,
            IsMyMeeting: isMyMeeting,
            IsOthersMeeting: isOthersMeeting,
            IsOver: data.Detail.IsHistory,
            IsHistory: data.Detail.IsHistory
          }
        });
      });
    }
    /**
     * 選択中の場合はtrue
     *
     * @param sessionId 会議ＩＤ
     */

  }, {
    key: "isSelected",
    value: function isSelected(sessionId) {
      return this.state.Selected != null && this.state.Selected.SessionId == sessionId;
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;

      this.props.common.bind();
      this.$file = $("#UploadMaterial");

      if (this.props.useLargeCapacityOption) {
        this.lastUpdate = Date.now();
        this.$file.fileupload({
          add: function add(_e, data) {
            var sessionId = $("#sessionId").val();

            if (sessionId == "") {
              if (data.files[0] == data.originalFiles[0]) {
                alert(intl.format(Errors.FileUploadSessionUnselected));
              }

              return;
            }

            var isOver = $("#isOver").val();

            if (isOver == "true") {
              if (data.files[0] == data.originalFiles[0]) {
                alert(intl.format(Errors.FileUploadSessionEnded));
              }

              return;
            }

            var uploadWarning = [];
            var uploadErrors = [];

            for (var i = 0; i < data.files.length; i++) {
              var material = data.files[i];
              data.fileName = material.name; // $MEMO: ファイル名をTrimする

              var materialFileName = "";

              if (material) {
                materialFileName = material.name;
                var fileNameWithoutExtention = materialFileName;

                if (materialFileName.lastIndexOf(".") != -1) {
                  fileNameWithoutExtention = materialFileName.substring(0, materialFileName.lastIndexOf(".")).trim();
                }

                var fileExtention = "";

                if (materialFileName.lastIndexOf(".") != -1) {
                  fileExtention = materialFileName.substring(materialFileName.lastIndexOf("."), materialFileName.length);
                }

                materialFileName = fileNameWithoutExtention + fileExtention;
              }

              if (materialFileList.filter(function (m) {
                return m.toLowerCase() == materialFileName.toLowerCase();
              }).length > 0) {
                uploadWarning.push("・".concat(materialFileName));
              }
            }

            if (uploadErrors.length > 0) {
              alert(uploadErrors.join("\n"));
              return;
            }

            if (uploadWarning.length > 0) {
              var message = intl.format(Errors.ConfirmFileExists);
              message = message.split('\\n').join('\n').concat(uploadWarning.join('\n'));
              var response = confirm(message);

              if (!response) {
                return;
              }
            }

            _this4.isSubmit = true;
            if (_this4.state.IsProcessing) return;
            setTimeout(function () {
              $("#overlay").fadeIn();
            });

            _this4.setState({
              IsProcessing: true,
              ErrorMessages: []
            });

            data.sessionId = Number(sessionId);
            data.files.forEach(function (file, index) {
              var singleData = $.extend({}, data);
              singleData.files = [file];
              var jqXHR = singleData.submit().done(function (result, textStatus, jqXHR) {
                var model = result;

                if (model.ResultCode == ApiResultCodes.SessionStorageShortage || model.ResultCode == ApiResultCodes.UnsupportedDataType || model.ResultCode == ApiResultCodes.LengthError) {
                  _this4.state.ErrorMessages.push(model.ResultMessage);

                  _this4.setState({
                    ErrorMessages: _this4.state.ErrorMessages
                  });

                  _this4.handleUploadFail(singleData);
                } else {
                  _this4.handleUploadDone(singleData);
                }
              }).fail(function (jqXHR, textStatus, errorThrown) {
                if (textStatus !== 'abort') {
                  _this4.state.ErrorMessages.push(intl.format(Errors.FileUploadFailed));

                  _this4.setState({
                    ErrorMessages: _this4.state.ErrorMessages
                  });

                  _this4.handleUploadFail(singleData);
                }
              });

              _this4.handleAddFiles(file, singleData, jqXHR);
            });
            setTimeout(function () {
              $("#overlay").fadeOut(300);
            }, 500);

            _this4.setState({
              IsProcessing: false
            });
          },
          url: "SessionApi/UploadMaterial",
          type: "POST",
          replaceFileInput: false,
          singleFileUploads: true,
          maxChunkSize: 4000000,
          timeout: 10800000,
          progress: function progress(e, data) {
            _this4.handleUploadProgress(data);
          }
        }).bind('fileuploadsubmit', function (e, data) {
          data.formData = {
            sessionId: data.sessionId
          };
        });
        ;
      } else {
        this.$file.fileupload({
          add: function add(_e, data) {
            var sessionId = $("#sessionId").val();

            if (sessionId == "") {
              alert(intl.format(Errors.FileUploadSessionUnselected));
              return;
            }

            var isOver = $("#isOver").val();

            if (isOver == "true") {
              alert(intl.format(Errors.FileUploadSessionEnded));
              return;
            }

            var uploadWarning = [];
            var uploadErrors = [];
            var uploadSizeWarning = "";
            var materialSize = 0;

            for (var i = 0; i < data.originalFiles.length; i++) {
              var material = data.originalFiles[i]; // $MEMO: ファイル名をTrimする

              var materialFileName = "";

              if (material) {
                materialFileName = material.name;
                var fileNameWithoutExtention = materialFileName;

                if (materialFileName.lastIndexOf(".") != -1) {
                  fileNameWithoutExtention = materialFileName.substring(0, materialFileName.lastIndexOf(".")).trim();
                }

                var fileExtention = "";

                if (materialFileName.lastIndexOf(".") != -1) {
                  fileExtention = materialFileName.substring(materialFileName.lastIndexOf("."), materialFileName.length);
                }

                materialFileName = fileNameWithoutExtention + fileExtention;
                materialSize += material.size;
              }

              if (materialFileList.filter(function (m) {
                return m.toLowerCase() == materialFileName.toLowerCase();
              }).length > 0) {
                uploadWarning.push("・".concat(materialFileName));
              }

              if (materialSize > 2147483648) {
                uploadSizeWarning = intl.format(Errors.ConfirmFileSize).split('\\n').join('\n');
              }
            }

            if (uploadErrors.length > 0) {
              alert(uploadErrors.join("\n"));
              return;
            }

            if (uploadWarning.length > 0) {
              var message = intl.format(Errors.ConfirmFileExists);
              message = message.split('\\n').join('\n').concat(uploadWarning.join('\n'));
              var response = confirm(message);

              if (!response) {
                return;
              }
            }

            if (uploadSizeWarning != "") {
              var response = confirm(uploadSizeWarning);

              if (!response) {
                return;
              }
            }

            this.isSubmit = true;
            data.submit();
          },
          url: "SessionApi/UploadMaterial",
          type: "POST",
          replaceFileInput: false,
          singleFileUploads: false,
          timeout: 10800000,
          start: function start(_e) {
            if (_this4.state.IsProcessing) return;
            setTimeout(function () {
              $("#overlay").fadeIn();
            });

            _this4.setState({
              IsProcessing: true,
              ErrorMessages: []
            });
          },
          done: function done(_e, data) {
            var model = data.result;

            if (model.ResultCode == ApiResultCodes.SessionStorageShortage || model.ResultCode == ApiResultCodes.UnsupportedDataType || model.ResultCode == ApiResultCodes.LengthError) {
              _this4.state.ErrorMessages.push(model.ResultMessage);

              _this4.setState({
                ErrorMessages: _this4.state.ErrorMessages
              });
            }

            Api.QueryDetail(model.Detail.SessionId, false, function (data) {
              setTimeout(function () {
                $("#overlay").fadeOut(300);
              }, 500);

              _this4.updateTempValue(data.Detail);

              var isHistory = _this4.state.Selected != null ? _this4.state.Selected.IsHistory : data.Detail.IsHistory;

              _this4.setState({
                IsProcessing: false,
                Sessions: data.Sessions,
                Selected: {
                  SessionId: data.Detail.SessionId,
                  Detail: data.Detail,
                  IsAllSelected: false,
                  SelectedFileName: null,
                  SelectedFileNames: [],
                  StreamingLocation: null,
                  StreamingStatus: null,
                  StreamingUrl: null,
                  SelectedGroupMaterial: null,
                  SelectedOriginalReductionRate: 0,
                  SelectedChangedReductionRate: 0,
                  SelectedOriginalPlaybackMode: 0,
                  SelectedChangedPlaybackMode: 0,
                  IsMyMeeting: data.Detail.IsMyMeeting,
                  IsOthersMeeting: data.Detail.IsOthersMeeting,
                  IsOver: data.Detail.IsHistory,
                  IsHistory: isHistory
                }
              });
            });
          },
          fail: function fail(_e, data) {
            _this4.state.ErrorMessages.push(intl.format(Errors.FileUploadFailed));

            _this4.setState({
              ErrorMessages: _this4.state.ErrorMessages
            });

            if (_this4.state.Selected == null) {
              setTimeout(function () {
                $("#overlay").fadeOut(300);
              }, 500);

              _this4.setState({
                IsProcessing: false
              });
            } else {
              Api.QueryDetail(_this4.state.Selected.SessionId, false, function (data) {
                setTimeout(function () {
                  $("#overlay").fadeOut(300);
                }, 500);

                _this4.updateTempValue(data.Detail);

                var isHistory = _this4.state.Selected != null ? _this4.state.Selected.IsHistory : data.Detail.IsHistory;

                _this4.setState({
                  IsProcessing: false,
                  Sessions: data.Sessions,
                  Selected: {
                    SessionId: data.Detail.SessionId,
                    Detail: data.Detail,
                    IsAllSelected: false,
                    SelectedFileName: null,
                    SelectedFileNames: [],
                    StreamingLocation: null,
                    StreamingStatus: null,
                    StreamingUrl: null,
                    SelectedGroupMaterial: null,
                    SelectedOriginalReductionRate: 0,
                    SelectedChangedReductionRate: 0,
                    SelectedOriginalPlaybackMode: 0,
                    SelectedChangedPlaybackMode: 0,
                    IsMyMeeting: data.Detail.IsMyMeeting,
                    IsOthersMeeting: data.Detail.IsOthersMeeting,
                    IsOver: data.Detail.IsHistory,
                    IsHistory: isHistory
                  }
                });
              });
            }
          }
        });
      }

      window.addEventListener('beforeunload', this.beforeunloadFunction);
    }
    /**
     * ComponentがDOMツリーから削除された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.QueryIntervalId != null) {
        clearInterval(this.state.QueryIntervalId);
      }

      window.removeEventListener('beforeunload', this.beforeunloadFunction);
    }
    /**
     *
     * @param file
     * @param data
     * @param jqXHR
     */

  }, {
    key: "handleAddFiles",
    value: function handleAddFiles(file, data, jqXHR) {
      if (data.sessionId && data.fileName) {
        var allUploadingFiles = _objectSpread({}, this.state.UploadingFiles);

        if (allUploadingFiles != null) {
          var _allUploadingFiles$da2;

          var uploadingFiles = (_allUploadingFiles$da2 = _objectSpread({}, allUploadingFiles[data.sessionId])) !== null && _allUploadingFiles$da2 !== void 0 ? _allUploadingFiles$da2 : {};

          if (file != null && file.name != null) {
            var uploadingState = new SessionMaterialStateInstanceModel();
            uploadingState.File = file;
            uploadingState.Progress = 0;
            uploadingState.LoadedSize = 0;
            uploadingState.TotalSize = file.size;
            uploadingState.Done = false;
            uploadingState.Error = false;
            uploadingState.Cancel = false;
            uploadingState.JqXHR = jqXHR;
            var uploadingFile = new SessionMaterialInstanceModel();
            uploadingFile.DisplayFileName = file.name;
            uploadingFile.MaterialFileName = file.name;
            uploadingFile.DisplayMaterialFileName = file.name;
            uploadingFile.MaterialFileExtension = this.getFileExtension(file.name);
            uploadingFile.UploadState = uploadingState;
            uploadingFiles[file.name] = uploadingFile;
            allUploadingFiles[data.sessionId] = uploadingFiles;
            this.setState({
              UploadingFiles: allUploadingFiles
            });
          }
        }
      }
    }
    /**
     * 拡張子取得処理
     *
     * @param fileName
     */

  }, {
    key: "getFileExtension",
    value: function getFileExtension(fileName) {
      var parts = fileName.split('.');
      return parts.length > 1 ? parts.pop() : '';
    }
    /**
     *
     * @param data
     */

  }, {
    key: "handleUploadProgress",
    value: function handleUploadProgress(data) {
      if (data.sessionId && data.fileName && data.loaded && data.total) {
        var now = Date.now();
        var interval = 500;
        var progress = Math.floor(data.loaded / data.total * 100);

        if (progress === 100 || now - this.lastUpdate >= interval) {
          this.lastUpdate = now;

          if (this.state.Selected != null) {
            var allUploadingFiles = _objectSpread({}, this.state.UploadingFiles);

            if (allUploadingFiles != null) {
              var _allUploadingFiles$da3;

              var uploadingFiles = (_allUploadingFiles$da3 = _objectSpread({}, allUploadingFiles[data.sessionId])) !== null && _allUploadingFiles$da3 !== void 0 ? _allUploadingFiles$da3 : {};

              if (uploadingFiles != null) {
                var _uploadingFiles$data$;

                var fileState = (_uploadingFiles$data$ = uploadingFiles[data.fileName]) === null || _uploadingFiles$data$ === void 0 ? void 0 : _uploadingFiles$data$.UploadState;

                if (fileState != null) {
                  fileState = _objectSpread(_objectSpread({}, fileState), {}, {
                    Progress: progress,
                    LoadedSize: data.loaded,
                    TotalSize: data.total
                  });
                  uploadingFiles[data.fileName] = _objectSpread(_objectSpread({}, uploadingFiles[data.fileName]), {}, {
                    UploadState: fileState
                  });
                }
              }

              allUploadingFiles[data.sessionId] = uploadingFiles;
              this.setState({
                UploadingFiles: allUploadingFiles
              });
            }
          }
        }
      }
    }
    /**
     *
     * @param data
     */

  }, {
    key: "handleUploadDone",
    value: function handleUploadDone(data) {
      if (data.sessionId && data.fileName) {
        var allUploadingFiles = _objectSpread({}, this.state.UploadingFiles);

        if (allUploadingFiles != null) {
          var _allUploadingFiles$da4;

          var uploadingFiles = (_allUploadingFiles$da4 = _objectSpread({}, allUploadingFiles[data.sessionId])) !== null && _allUploadingFiles$da4 !== void 0 ? _allUploadingFiles$da4 : {};

          if (uploadingFiles != null) {
            var _uploadingFiles$data$2;

            var fileState = (_uploadingFiles$data$2 = uploadingFiles[data.fileName]) === null || _uploadingFiles$data$2 === void 0 ? void 0 : _uploadingFiles$data$2.UploadState;

            if (fileState != null) {
              fileState = _objectSpread(_objectSpread({}, fileState), {}, {
                Done: true,
                JqXHR: undefined
              });
              uploadingFiles[data.fileName] = _objectSpread(_objectSpread({}, uploadingFiles[data.fileName]), {}, {
                UploadState: fileState
              });
            }
          }

          allUploadingFiles[data.sessionId] = uploadingFiles;
          this.setState({
            UploadingFiles: allUploadingFiles
          });
        }
      }
    }
    /**
     *
     * @param data
     */

  }, {
    key: "handleUploadFail",
    value: function handleUploadFail(data) {
      if (data.sessionId && data.fileName) {
        var allUploadingFiles = _objectSpread({}, this.state.UploadingFiles);

        if (allUploadingFiles != null) {
          var _allUploadingFiles$da5;

          var uploadingFiles = (_allUploadingFiles$da5 = _objectSpread({}, allUploadingFiles[data.sessionId])) !== null && _allUploadingFiles$da5 !== void 0 ? _allUploadingFiles$da5 : {};

          if (uploadingFiles != null) {
            var _uploadingFiles$data$3;

            var fileState = (_uploadingFiles$data$3 = uploadingFiles[data.fileName]) === null || _uploadingFiles$data$3 === void 0 ? void 0 : _uploadingFiles$data$3.UploadState;

            if (fileState != null) {
              fileState = _objectSpread(_objectSpread({}, fileState), {}, {
                Error: true,
                JqXHR: undefined
              });
              uploadingFiles[data.fileName] = _objectSpread(_objectSpread({}, uploadingFiles[data.fileName]), {}, {
                UploadState: fileState
              });
            }
          }

          allUploadingFiles[data.sessionId] = uploadingFiles;
          this.setState({
            UploadingFiles: allUploadingFiles
          });
        }
      }
    }
    /**
     *
     * @param fileName
     */

  }, {
    key: "onAbortUpload",
    value: function onAbortUpload(fileName, fileState) {
      if (fileName == null || fileState == null) return;

      if (this.state.Selected != null && this.state.UploadingFiles != null) {
        var allUploadingFiles = _objectSpread({}, this.state.UploadingFiles);

        var uploadingFiles = _objectSpread({}, allUploadingFiles[this.state.Selected.SessionId]);

        if (fileState && fileState.JqXHR) {
          fileState.JqXHR.abort();
          fileState.JqXHR = undefined;
        }

        delete uploadingFiles[fileName];
        allUploadingFiles[this.state.Selected.SessionId] = uploadingFiles;
        this.setState({
          UploadingFiles: allUploadingFiles
        });
      }
    } ///**
    // * 
    // * @param fileName
    // */
    //handleRetryUpload(fileName: string) {
    //}

    /**
     * 会議モーダルを追加で起動します。
     */

  }, {
    key: "openAddSessionModal",
    value: function openAddSessionModal() {
      this.setState({
        IsProcessing: true,
        ErrorMessages: [],
        SessionModalMode: SessionModalComponent.Mode.Add,
        TargetFolderName: this.getGuid(),
        ModifiedSessionId: null,
        ModifiedSessionName: null,
        ModifiedStartDate: null,
        ModifiedStartTimeHours: null,
        ModifiedStartTimeMinutes: null,
        ModifiedEndDate: null,
        ModifiedEndTimeHours: null,
        ModifiedEndTimeMinutes: null,
        ModifiedSpecifyPeriod: null,
        ModifiedUseState: null,
        ModifiedUseMember: null,
        ModifiedScene: null
      });
    }
    /**
     * 会議モーダルを編集で起動します。
     */

  }, {
    key: "openModifySessionModal",
    value: function openModifySessionModal() {
      this.setState({
        IsProcessing: true,
        ErrorMessages: [],
        SessionModalMode: SessionModalComponent.Mode.Modify,
        TargetFolderName: this.state.Selected ? Utility.NullNumberToBlank(this.state.Selected.Detail.SessionId) : this.getGuid(),
        ModifiedSessionId: null,
        ModifiedSessionName: null,
        ModifiedStartDate: null,
        ModifiedStartTimeHours: null,
        ModifiedStartTimeMinutes: null,
        ModifiedEndDate: null,
        ModifiedEndTimeHours: null,
        ModifiedEndTimeMinutes: null,
        ModifiedSpecifyPeriod: null,
        ModifiedUseState: null,
        ModifiedUseMember: null,
        ModifiedScene: null
      });
    }
    /**
     * 会議モーダルを表示のみで起動します。
     */

  }, {
    key: "openReadonlySessionModal",
    value: function openReadonlySessionModal() {
      this.setState({
        IsProcessing: true,
        ErrorMessages: [],
        SessionModalMode: SessionModalComponent.Mode.ReadOnly,
        TargetFolderName: this.state.Selected ? Utility.NullNumberToBlank(this.state.Selected.Detail.SessionId) : this.getGuid(),
        ModifiedSessionId: null,
        ModifiedScene: null
      });
    }
    /**
     * 会議を登録します。
     *
     * @param sessionName 会議名
     * @param startDateTime 開始日
     * @param endDateTime 終了日
     * @param sceneModelName シーンモデル名
     * @param sceneImageName シーンイメージ名
     * @param targetFolderName ターゲットフォルダ名
     */

  }, {
    key: "entrySessionModal",
    value: function entrySessionModal(sessionName, startDateTime, endDateTime, sceneModelName, sceneImageName, targetFolderName) {
      var _this5 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.AddSession(sessionName, startDateTime, endDateTime, sceneModelName, sceneImageName, targetFolderName, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        _this5.updateTempValue(data.Detail);

        _this5.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: {
            SessionId: data.Detail.SessionId,
            Detail: data.Detail,
            SelectedFileName: null,
            SelectedFileNames: [],
            StreamingLocation: null,
            StreamingStatus: null,
            StreamingUrl: null,
            SelectedGroupMaterial: null,
            SelectedOriginalReductionRate: 0,
            SelectedChangedReductionRate: 0,
            SelectedOriginalPlaybackMode: 0,
            SelectedChangedPlaybackMode: 0,
            IsMyMeeting: true,
            IsOthersMeeting: false,
            IsOver: data.Detail.IsHistory,
            IsHistory: false,
            IsAllSelected: false
          },
          TargetFolderName: Utility.NullNumberToBlank(data.Detail.SessionId)
        });
      });
    }
    /**
     * 会議を更新します。
     *
     * @param sessionId 会議ＩＤ
     * @param sessionName 会議名
     * @param startDateTime 開始日
     * @param endDateTime 終了日
     * @param sceneModelName シーンモデル名
     * @param sceneImageName シーンイメージ名
     * @param updateDateTime 更新日時
     */

  }, {
    key: "modifySessionModel",
    value: function modifySessionModel(sessionId, sessionName, startDateTime, endDateTime, sceneModelName, sceneImageName, updateDateTime) {
      var _this6 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.ModifySession(sessionId, sessionName, startDateTime, endDateTime, sceneModelName, sceneImageName, updateDateTime, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        var selected = _this6.setDetail(data.Detail);

        _this6.updateTempValue(selected.Detail);

        _this6.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: selected
        });
      });
    }
    /**
     * 会議を複製します。
     *
     * @param sessionId 会議ＩＤ
     */

  }, {
    key: "duplicateSessionModal",
    value: function duplicateSessionModal() {
      var _this7 = this;

      if (this.state.Selected == null) return;
      var isHistory = this.state.Selected.IsHistory;
      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.QueryDetail(this.state.Selected.SessionId, false, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        _this7.updateTempValue(data.Detail);

        _this7.setState({
          IsProcessing: false
        });

        _this7.setState({
          Sessions: data.Sessions,
          Selected: {
            SessionId: data.Detail.SessionId,
            Detail: data.Detail,
            IsAllSelected: false,
            SelectedFileName: null,
            SelectedFileNames: [],
            StreamingLocation: null,
            StreamingStatus: null,
            StreamingUrl: null,
            SelectedGroupMaterial: null,
            SelectedOriginalReductionRate: 0,
            SelectedChangedReductionRate: 0,
            SelectedOriginalPlaybackMode: 0,
            SelectedChangedPlaybackMode: 0,
            IsMyMeeting: data.Detail.IsMyMeeting,
            IsOthersMeeting: data.Detail.IsOthersMeeting,
            IsOver: data.Detail.IsHistory,
            IsHistory: isHistory
          }
        }, function () {
          _this7.setState({
            IsProcessing: true,
            ErrorMessages: [],
            SessionCopyModalMode: SessionCopyModalComponent.Mode.Copy,
            TargetFolderName: _this7.getGuid(),
            ModifiedSessionId: null,
            ModifiedSessionName: null,
            ModifiedStartDate: null,
            ModifiedStartTimeHours: null,
            ModifiedStartTimeMinutes: null,
            ModifiedEndDate: null,
            ModifiedEndTimeHours: null,
            ModifiedEndTimeMinutes: null,
            ModifiedSpecifyPeriod: null,
            ModifiedUseState: null,
            ModifiedUseMember: null,
            ModifiedScene: null
          });
        });
      });
    }
    /**
     * 会議を削除します。
     *
     * @param sessionId 会議ＩＤ
     * @param updateDateTime 更新日時
     */

  }, {
    key: "deleteSessionModal",
    value: function deleteSessionModal(sessionId, updateDateTime) {
      var _this8 = this;

      this.state.ErrorMessages.length = 0;
      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.DeleteSession(sessionId, updateDateTime, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        _this8.clearTempValue();

        _this8.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: null
        });
      });
    }
    /**
     * 会議をコピーします。
     *
     * @param baseSessionId コピー元会議ID
     * @param sessionName 会議名
     * @param startDateTime 開始日
     * @param endDateTime 終了日
     * @param sceneModelName シーンモデル名
     * @param sceneImageName シーンイメージ名
     * @param targetFolderName ターゲットフォルダ名
     * @param useState 保存状態利用
     * @param useMember 保存メンバー利用
     */

  }, {
    key: "copySessionModal",
    value: function copySessionModal(baseSessionId, sessionName, startDateTime, endDateTime, sceneModelName, sceneImageName, targetFolderName, useState, useMember) {
      var _this9 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.CopySession(baseSessionId, sessionName, startDateTime, endDateTime, sceneModelName, sceneImageName, targetFolderName, useState, useMember, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        _this9.updateTempValue(data.Detail);

        _this9.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: {
            SessionId: data.Detail.SessionId,
            Detail: data.Detail,
            SelectedFileName: null,
            SelectedFileNames: [],
            StreamingLocation: null,
            StreamingStatus: null,
            StreamingUrl: null,
            SelectedGroupMaterial: null,
            SelectedOriginalReductionRate: 0,
            SelectedChangedReductionRate: 0,
            SelectedOriginalPlaybackMode: 0,
            SelectedChangedPlaybackMode: 0,
            IsMyMeeting: true,
            IsOthersMeeting: false,
            IsOver: data.Detail.IsHistory,
            IsHistory: false,
            IsAllSelected: false
          },
          TargetFolderName: Utility.NullNumberToBlank(data.Detail.SessionId)
        });
      });
    }
    /**
     * 会議のシーンを変更します。
     *
     * @param baseSessionId
     */

  }, {
    key: "changeSceneSessionModal",
    value: function changeSceneSessionModal(baseSessionId, sessionName, startDate, startTimeHours, startTimeMinutes, endDate, endTimeHours, endTimeMinutes, specifyPeriod, useState, useMember, scene) {
      var savedMode = this.state.SessionModalMode;
      var savedCopyMode = this.state.SessionCopyModalMode;
      this.setState({
        IsProcessing: true,
        ErrorMessages: [],
        SessionSceneModalMode: SessionSceneModalComponent.Mode.Show,
        SavedSessionModalMode: savedMode,
        SavedSessionCopyModalMode: savedCopyMode,
        ModifiedSessionId: baseSessionId,
        ModifiedSessionName: sessionName,
        ModifiedStartDate: startDate,
        ModifiedStartTimeHours: startTimeHours,
        ModifiedStartTimeMinutes: startTimeMinutes,
        ModifiedEndDate: endDate,
        ModifiedEndTimeHours: endTimeHours,
        ModifiedEndTimeMinutes: endTimeMinutes,
        ModifiedSpecifyPeriod: specifyPeriod,
        ModifiedUseState: useState,
        ModifiedUseMember: useMember,
        ModifiedScene: scene
      });
    }
    /**
     * 会議モーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenSessionModal",
    value: function hiddenSessionModal() {
      this.setState({
        IsProcessing: false,
        SessionModalMode: SessionModalComponent.Mode.None
      });
    }
    /**
     * 会議モーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenSessionCopyModal",
    value: function hiddenSessionCopyModal() {
      this.setState({
        IsProcessing: false,
        SessionCopyModalMode: SessionCopyModalComponent.Mode.None
      });
    }
    /**
     * 会議シーン選択モーダルの「決定」ボタン押下時の処理をします。
     *
     * @param scene シーン
     */

  }, {
    key: "decideSessionSceneModal",
    value: function decideSessionSceneModal(scene) {
      var savedMode = this.state.SavedSessionModalMode;
      var savedCopyMode = this.state.SavedSessionCopyModalMode;
      this.setState({
        SessionModalMode: savedMode,
        SessionCopyModalMode: savedCopyMode,
        SavedSessionModalMode: SessionModalComponent.Mode.None,
        SavedSessionCopyModalMode: SessionCopyModalComponent.Mode.None,
        ModifiedScene: scene
      });
    }
    /**
     * 会議シーン選択モーダルの「戻る」ボタン押下時の処理をします。
     */

  }, {
    key: "backSessionSceneModal",
    value: function backSessionSceneModal() {
      var savedMode = this.state.SavedSessionModalMode;
      var savedCopyMode = this.state.SavedSessionCopyModalMode;
      this.setState({
        SessionModalMode: savedMode,
        SessionCopyModalMode: savedCopyMode,
        SavedSessionModalMode: SessionModalComponent.Mode.None,
        SavedSessionCopyModalMode: SessionCopyModalComponent.Mode.None
      });
    }
    /**
     * 会議シーン選択モーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenSessionSceneModal",
    value: function hiddenSessionSceneModal() {
      this.setState({
        IsProcessing: false,
        SessionSceneModalMode: SessionSceneModalComponent.Mode.None
      });
    }
    /**
     * メンバーモーダルを編集で起動します。
     */

  }, {
    key: "openModifyMemberModal",
    value: function openModifyMemberModal() {
      this.setState({
        IsProcessing: true,
        ErrorMessages: [],
        MemberModalMode: MemberModalComponent.Mode.Modify
      });
    }
    /**
     * メンバーモーダルを表示で起動します。
     */

  }, {
    key: "openReadonlyMemberModal",
    value: function openReadonlyMemberModal() {
      this.setState({
        IsProcessing: true,
        ErrorMessages: [],
        MemberModalMode: MemberModalComponent.Mode.ReadOnly
      });
    }
    /**
     * メンバーを更新します。
     *
     * @param sessionId 会議ID
     * @param targetList 対象ユーザーＩＤリスト
     */

  }, {
    key: "modifyMemberModal",
    value: function modifyMemberModal(sessionId, targetList, updateDateTime) {
      var _this10 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.ModifyMember(sessionId, targetList, updateDateTime, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        var selected = _this10.setDetail(data.Detail);

        _this10.updateTempValue(selected.Detail);

        _this10.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: selected
        });
      });
    }
    /**
     * メンバーモーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenMemberModal",
    value: function hiddenMemberModal() {
      this.setState({
        IsProcessing: false,
        MemberModalMode: MemberModalComponent.Mode.None
      });
    }
    /**
     * ファイルアップロードボタン押下時の処理を行います。
     */

  }, {
    key: "fileupload",
    value: function fileupload() {
      this.$file.click();
    }
    /**
     * 地形生成モーダルを起動します。
     */

  }, {
    key: "openTerrainModelingModal",
    value: function openTerrainModelingModal() {
      this.setState({
        IsProcessing: true,
        ErrorMessages: [],
        TerrainModelingModalMode: TerrainModelingModalComponent.Mode.Show
      });
    }
    /**
     * 地形情報を登録します。
     *
     * @param sessionId セッションＩＤ
     * @param materialFileName マテリアル名
     * @param latitude 緯度
     * @param longitude 経度
     * @param level 表示範囲
     */

  }, {
    key: "entryTerrainModel",
    value: function entryTerrainModel(sessionId, materialFileName, latitude, longitude, level) {
      var _this11 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.EntryTerrain(sessionId, materialFileName, latitude, longitude, level, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        var selected = _this11.setDetail(data.Detail);

        _this11.updateTempValue(selected.Detail);

        _this11.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: selected
        });
      });
    }
    /**
     * 地形生成モーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenTerrainModelingModal",
    value: function hiddenTerrainModelingModal() {
      this.setState({
        IsProcessing: false,
        TerrainModelingModalMode: TerrainModelingModalComponent.Mode.None
      });
    }
    /**
     * ポータル生成モーダルを起動します。
     */

  }, {
    key: "openPortalModal",
    value: function openPortalModal() {
      this.setState({
        IsProcessing: true,
        ErrorMessages: [],
        PortalModalMode: SessionPortalModalComponent.Mode.Add
      });
    }
    /**
     * ポータルを登録します。
     *
     * @param sessionId セッションＩＤ
     * @param materialFileName マテリアル名
     * @param privateModeOnly 強制プライベートモードフラグ
     */

  }, {
    key: "entryPortalModel",
    value: function entryPortalModel(sessionId, materialFileName, privateModeOnly) {
      var _this12 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.EntryPortal(sessionId, materialFileName, privateModeOnly, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        var selected = _this12.setDetail(data.Detail);

        _this12.updateTempValue(selected.Detail);

        _this12.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: selected
        });
      });
    }
    /**
     * ポータル生成モーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenPortalModal",
    value: function hiddenPortalModal() {
      this.setState({
        IsProcessing: false,
        PortalModalMode: SessionPortalModalComponent.Mode.None
      });
    }
    /**
     * ストリーミング生成モーダルを起動します。
     */

  }, {
    key: "openStreamingModal",
    value: function openStreamingModal() {
      this.setState({
        IsProcessing: true,
        ErrorMessages: [],
        SessionStreamingModalMode: SessionStreamingModalComponent.Mode.Add
      });
    }
    /**
     * ストリーミングを登録します。
     *
     * @param sessionId セッションＩＤ
     * @param materialFileName マテリアル名
     */

  }, {
    key: "entryStreamingModel",
    value: function entryStreamingModel(sessionId, materialFileName) {
      var _this13 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.EntryStreaming(sessionId, materialFileName, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        var selected = _this13.setDetail(data.Detail);

        _this13.updateTempValue(selected.Detail);

        _this13.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: selected
        });
      });
    }
    /**
     * ストリーミング生成モーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenStreamingModal",
    value: function hiddenStreamingModal() {
      this.setState({
        IsProcessing: false,
        SessionStreamingModalMode: SessionStreamingModalComponent.Mode.None
      });
    }
    /**
     * ストリーミング設定モーダルを起動します。
     */

  }, {
    key: "openStreamingSettingModal",
    value: function openStreamingSettingModal(m) {
      var selected = this.state.Selected;

      if (selected) {
        selected.StreamingLocation = m.MaterialFileName;
        selected.StreamingStatus = m.StreamingStatus;
        selected.StreamingUrl = m.StreamingUrl;
      }

      this.setState({
        IsProcessing: true,
        ErrorMessages: [],
        SessionStreamingSettingModalMode: SessionStreamingSettingModalComponent.Mode.Modify,
        Selected: selected
      });
    }
    /**
     * 配信URLを通知します。
     *
     * @param sessionId セッションＩＤ
     * @param materialFileName マテリアル名
     * @param mailAddresses 通知先アドレス
     */

  }, {
    key: "notifyStreamingSettingModel",
    value: function notifyStreamingSettingModel(sessionId, materialFileName, mailAddresses) {
      var _this14 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.EntryStreaming(sessionId, materialFileName, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        var selected = _this14.setDetail(data.Detail);

        _this14.updateTempValue(selected.Detail);

        _this14.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: selected
        });
      });
    }
    /**
     * ストリーミング設定モーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenStreamingSettingModal",
    value: function hiddenStreamingSettingModal() {
      this.setState({
        IsProcessing: false,
        SessionStreamingSettingModalMode: SessionStreamingSettingModalComponent.Mode.None
      });
    }
    /**
     * 素材更新履歴モーダルを起動します。
     */

  }, {
    key: "openMaterialHistoryModal",
    value: function openMaterialHistoryModal() {
      this.setState({
        IsProcessing: true,
        ErrorMessages: [],
        SessionActionsHistoryModalMode: SessionActionsHistoryModalComponent.Mode.ReadOnly
      });
    }
    /**
     * 素材更新履歴モーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenMaterialHistoryModal",
    value: function hiddenMaterialHistoryModal() {
      this.setState({
        IsProcessing: false,
        SessionActionsHistoryModalMode: SessionActionsHistoryModalComponent.Mode.None
      });
    }
    /**
     * オーサリングメニューが選ばれた際の処理を行います。
     */

  }, {
    key: "selectMemuAuthoringMenuModal",
    value: function selectMemuAuthoringMenuModal(mode) {
      if (this.state.Selected == null) return;

      switch (mode) {
        case SessionAuthoringMenuModalComponent.MenuMode.EditSequence:
          this.setState({
            SessionAuthoringModalMode: this.state.Selected.IsHistory && this.state.Selected.IsOver ? SessionAuthoringModalComponent.Mode.ReadOnly : SessionAuthoringModalComponent.Mode.Modify,
            SessionAuthoringModalAuthoringMode: SessionAuthoringModalComponent.AuthoringMode.Sequences,
            SessionAuthoringMenuModalMode: SessionAuthoringMenuModalComponent.Mode.None
          });
          break;

        case SessionAuthoringMenuModalComponent.MenuMode.EditInteraction:
          this.setState({
            SessionAuthoringModalMode: this.state.Selected.IsHistory && this.state.Selected.IsOver ? SessionAuthoringModalComponent.Mode.ReadOnly : SessionAuthoringModalComponent.Mode.Modify,
            SessionAuthoringModalAuthoringMode: SessionAuthoringModalComponent.AuthoringMode.Interactions,
            SessionAuthoringMenuModalMode: SessionAuthoringMenuModalComponent.Mode.None
          });
          break;

        case SessionAuthoringMenuModalComponent.MenuMode.AddEmpty:
          this.setState({
            SessionAuthoringEmptyModalMode: SessionAuthoringEmptyModalComponent.Mode.Add,
            SessionAuthoringMenuModalMode: SessionAuthoringMenuModalComponent.Mode.None
          });
          break;

        case SessionAuthoringMenuModalComponent.MenuMode.AddTextPanel:
          this.setState({
            SessionAuthoringTextPanelModalMode: SessionAuthoringTextPanelModalComponent.Mode.Add,
            SessionAuthoringMenuModalMode: SessionAuthoringMenuModalComponent.Mode.None
          });
          break;

        case SessionAuthoringMenuModalComponent.MenuMode.ManageMessage:
          this.setState({
            SessionAuthoringMessageModalMode: SessionAuthoringMessageModalComponent.Mode.Add,
            SessionAuthoringMenuModalMode: SessionAuthoringMenuModalComponent.Mode.None
          });
          break;

        case SessionAuthoringMenuModalComponent.MenuMode.AddEffect:
          this.setState({
            SessionAuthoringEffectModalMode: SessionAuthoringEffectModalComponent.Mode.Add,
            SessionAuthoringMenuModalMode: SessionAuthoringMenuModalComponent.Mode.None
          });
          break;

        case SessionAuthoringMenuModalComponent.MenuMode.AddDataPanel:
          this.setState({
            SessionAuthoringDataPanelModalMode: SessionAuthoringDataPanelModalComponent.Mode.Add,
            SessionAuthoringMenuModalMode: SessionAuthoringMenuModalComponent.Mode.None
          });
          break;
      }
    }
    /**
     * オーサリングメニューモーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenAuthoringMenuModal",
    value: function hiddenAuthoringMenuModal() {
      this.setState({
        IsProcessing: this.state.SessionAuthoringMenuModalMode != SessionAuthoringMenuModalComponent.Mode.None,
        SessionAuthoringMenuModalMode: SessionAuthoringMenuModalComponent.Mode.None
      });
    }
    /**
     * オーサリングメニューモーダルを起動します。
     */

  }, {
    key: "openAuthoringModal",
    value: function openAuthoringModal() {
      if (this.state.Selected == null) return; // メニューを開く

      this.setState({
        IsProcessing: true,
        ErrorMessages: [],
        SessionAuthoringMenuModalMode: this.state.Selected.IsHistory && this.state.Selected.IsOver ? SessionAuthoringMenuModalComponent.Mode.ReadOnly : SessionAuthoringMenuModalComponent.Mode.Show
      });
    }
    /**
     * オーサリング編集モーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenAuthoringModal",
    value: function hiddenAuthoringModal() {
      this.setState({
        IsProcessing: false,
        SessionAuthoringModalMode: SessionAuthoringModalComponent.Mode.None,
        SessionAuthoringModalAuthoringMode: SessionAuthoringModalComponent.AuthoringMode.Interactions
      });
    }
    /**
     * トリガーオブジェクト追加モーダルからの登録イベントを処理を行います。
     */

  }, {
    key: "addAuthoringEmptyModal",
    value: function addAuthoringEmptyModal(materialFileName, fn) {
      var _this15 = this;

      if (this.state.Selected == null) return;
      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.EntryAuthoringMaterial(this.state.Selected.Detail.SessionId, materialFileName, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        var selected = _this15.setDetail(data.Detail);

        _this15.updateTempValue(selected.Detail);

        _this15.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: selected
        }, function () {
          fn();
        });
      });
    }
    /**
     * トリガーオブジェクト追加モーダルからの戻るイベントを処理を行います。
     */

  }, {
    key: "backAuthoringEmptyModal",
    value: function backAuthoringEmptyModal() {
      if (this.state.Selected == null) return;
      this.setState({
        SessionAuthoringMenuModalMode: this.state.Selected.IsHistory && this.state.Selected.IsOver ? SessionAuthoringMenuModalComponent.Mode.ReadOnly : SessionAuthoringMenuModalComponent.Mode.Show,
        SessionAuthoringEmptyModalMode: SessionAuthoringEmptyModalComponent.Mode.None
      });
    }
    /**
     * トリガーオブジェクト追加モーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenAuthoringEmptyModal",
    value: function hiddenAuthoringEmptyModal() {
      this.setState({
        IsProcessing: false,
        SessionAuthoringEmptyModalMode: SessionAuthoringEmptyModalComponent.Mode.None
      });
    }
    /**
     * エフェクト追加モーダルからの登録イベントを処理を行います。
     */

  }, {
    key: "addAuthoringEffectModal",
    value: function addAuthoringEffectModal(materialFileName, fn) {
      var _this16 = this;

      if (this.state.Selected == null) return;
      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.EntryAuthoringMaterial(this.state.Selected.Detail.SessionId, materialFileName, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        var selected = _this16.setDetail(data.Detail);

        _this16.updateTempValue(selected.Detail);

        _this16.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: selected
        }, function () {
          fn();
        });
      });
    }
    /**
     * エフェクト追加モーダルからの戻るイベントを処理を行います。
     */

  }, {
    key: "backAuthoringEffectModal",
    value: function backAuthoringEffectModal() {
      if (this.state.Selected == null) return;
      this.setState({
        SessionAuthoringMenuModalMode: this.state.Selected.IsHistory && this.state.Selected.IsOver ? SessionAuthoringMenuModalComponent.Mode.ReadOnly : SessionAuthoringMenuModalComponent.Mode.Show,
        SessionAuthoringEffectModalMode: SessionAuthoringEffectModalComponent.Mode.None
      });
    }
    /**
     * エフェクト追加モーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenAuthoringEffectModal",
    value: function hiddenAuthoringEffectModal() {
      this.setState({
        IsProcessing: false,
        SessionAuthoringEffectModalMode: SessionAuthoringEffectModalComponent.Mode.None
      });
    }
    /**
     * テキストパネル追加モーダルからの登録イベントを処理を行います。
     */

  }, {
    key: "addAuthoringTextPanelModal",
    value: function addAuthoringTextPanelModal(materialFileName, fn) {
      var _this17 = this;

      if (this.state.Selected == null) return;
      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.EntryAuthoringMaterial(this.state.Selected.Detail.SessionId, materialFileName, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        var selected = _this17.setDetail(data.Detail);

        _this17.updateTempValue(selected.Detail);

        _this17.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: selected
        }, function () {
          fn();
        });
      });
    }
    /**
     * テキストパネル追加モーダルからの戻るイベントを処理を行います。
     */

  }, {
    key: "backAuthoringTextPanelModal",
    value: function backAuthoringTextPanelModal() {
      if (this.state.Selected == null) return;
      this.setState({
        SessionAuthoringMenuModalMode: this.state.Selected.IsHistory && this.state.Selected.IsOver ? SessionAuthoringMenuModalComponent.Mode.ReadOnly : SessionAuthoringMenuModalComponent.Mode.Show,
        SessionAuthoringTextPanelModalMode: SessionAuthoringTextPanelModalComponent.Mode.None
      });
    }
    /**
     * テキストパネル追加モーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenAuthoringTextPanelModal",
    value: function hiddenAuthoringTextPanelModal() {
      this.setState({
        IsProcessing: false,
        SessionAuthoringTextPanelModalMode: SessionAuthoringTextPanelModalComponent.Mode.None
      });
    }
    /**
     * メッセージ管理モーダルからの戻るイベントを処理を行います。
     */

  }, {
    key: "backAuthoringMessageModal",
    value: function backAuthoringMessageModal() {
      if (this.state.Selected == null) return;
      this.setState({
        SessionAuthoringMenuModalMode: this.state.Selected.IsHistory && this.state.Selected.IsOver ? SessionAuthoringMenuModalComponent.Mode.ReadOnly : SessionAuthoringMenuModalComponent.Mode.Show,
        SessionAuthoringMessageModalMode: SessionAuthoringMessageModalComponent.Mode.None
      });
    }
    /**
     * メッセージ管理モーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenAuthoringMessageModal",
    value: function hiddenAuthoringMessageModal() {
      this.setState({
        IsProcessing: false,
        SessionAuthoringMessageModalMode: SessionAuthoringMessageModalComponent.Mode.None
      });
    }
    /**
     * データパネル管理モーダルからの戻るイベントを処理を行います。
     */

  }, {
    key: "backAuthoringDataPanelModal",
    value: function backAuthoringDataPanelModal() {
      if (this.state.Selected == null) return;
      this.setState({
        SessionAuthoringMenuModalMode: this.state.Selected.IsHistory && this.state.Selected.IsOver ? SessionAuthoringMenuModalComponent.Mode.ReadOnly : SessionAuthoringMenuModalComponent.Mode.Show,
        SessionAuthoringDataPanelModalMode: SessionAuthoringDataPanelModalComponent.Mode.None
      });
    }
    /**
     * データパネル管理モーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenAuthoringDataPanelModal",
    value: function hiddenAuthoringDataPanelModal() {
      this.setState({
        IsProcessing: false,
        SessionAuthoringDataPanelModalMode: SessionAuthoringDataPanelModalComponent.Mode.None
      });
    }
    /**
     * 配置オフセットモーダルを起動します。
     */

  }, {
    key: "openSessionOffsetModal",
    value: function openSessionOffsetModal() {
      this.setState({
        IsProcessing: true,
        ErrorMessages: [],
        SessionOffsetModalMode: SessionOffsetModalComponent.Mode.Show
      });
    }
    /**
     * 配置オフセットモーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenSessionOffsetModal",
    value: function hiddenSessionOffsetModal() {
      this.setState({
        IsProcessing: false,
        SessionOffsetModalMode: SessionOffsetModalComponent.Mode.None
      });
    }
    /**
     * QRコードモーダルを起動します。
     */

  }, {
    key: "openQrCodeModal",
    value: function openQrCodeModal() {
      this.setState({
        IsProcessing: true,
        ErrorMessages: [],
        QrCodeModalMode: QrCodeModalComponent.Mode.ReadOnly
      });
    }
    /**
     * QRコードモーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenQrCodeModal",
    value: function hiddenQrCodeModal() {
      this.setState({
        IsProcessing: false,
        QrCodeModalMode: QrCodeModalComponent.Mode.None
      });
    }
    /**
     * グループ作成モーダルを起動します。
     */

  }, {
    key: "openAddGroupMaterialModal",
    value: function openAddGroupMaterialModal() {
      var _selected$Detail;

      var selected = this.state.Selected;
      if (!selected || !selected.Detail || !selected.Detail.MaterialList) return;
      var numbers = [];
      var groupPrefix = intl.format(Label.Group);
      var regex = new RegExp("^" + groupPrefix + "(\\d+)\\.sg$");
      selected.Detail.MaterialList.filter(function (file) {
        return file.MaterialFileExtension === ".sg";
      }).forEach(function (file) {
        var match = file.MaterialFileName.match(regex);

        if (match) {
          numbers.push(parseInt(match[1], 10));
        }
      });
      var maxNumber = (numbers.length > 0 ? Math.max.apply(Math, numbers) : 0) + 1;
      var groupName = intl.format(Label.Group) + maxNumber.toString().padStart(3, "0") + ".sg";
      var displayName = intl.format(Label.Group) + maxNumber.toString().padStart(3, "0");
      var groupMaterial = new UploadGroupMaterialsInstanceModel();
      groupMaterial.SessionId = selected.SessionId;
      groupMaterial.MaterialFileName = groupName;
      groupMaterial.DisplayFileName = displayName;
      var includes = selected.SelectedFileNames;
      var id = 0;
      (_selected$Detail = selected.Detail) === null || _selected$Detail === void 0 ? void 0 : _selected$Detail.MaterialList.filter(function (m) {
        return m.Is3D && m.MaterialFileExtension.toLowerCase() != ".sg";
      }).forEach(function (m) {
        var _ref;

        var groupMaterialsItem = new UploadGroupMaterialsItemInstanceModel();
        groupMaterialsItem.SessionId = groupMaterial.SessionId;
        groupMaterialsItem.MaterialFileName = groupMaterial.MaterialFileName;
        groupMaterialsItem.ItemId = id;
        groupMaterialsItem.ItemName = m.MaterialFileName;
        groupMaterialsItem.LastModified = m.LastModified;
        groupMaterialsItem.Included = (_ref = (includes === null || includes === void 0 ? void 0 : includes.indexOf(m.MaterialFileName)) !== -1) !== null && _ref !== void 0 ? _ref : false;

        if (!groupMaterial.Items) {
          groupMaterial.Items = [];
        }

        groupMaterial.Items.push(groupMaterialsItem);
        id++;
      });

      if (selected) {
        selected.SelectedGroupMaterial = groupMaterial;
      }

      this.setState({
        IsProcessing: true,
        ErrorMessages: [],
        SessionGroupMaterialModalMode: SessionGroupMaterialModalComponent.Mode.Add,
        Selected: selected
      });
    }
    /**
     * グループを登録します。
     *
     * @param model モデル
     */

  }, {
    key: "entryGroupMaterial",
    value: function entryGroupMaterial(model) {
      var _this18 = this;

      var fileNameArray = [];
      model.Items.filter(function (item) {
        return item.Included;
      }).map(function (item) {
        if (item.ItemName) {
          fileNameArray.push(item.ItemName);
        }
      });
      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.AddMaterial(model.SessionId, model.MaterialFileName, fileNameArray, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        var selected = _this18.setDetail(data.Detail);

        _this18.updateTempValue(selected.Detail);

        _this18.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: selected
        });
      });
    }
    /**
     * グループ編集モーダルを起動します。
     */

  }, {
    key: "openModifyGroupMaterialModal",
    value: function openModifyGroupMaterialModal(m) {
      var _selected$Detail2, _selected$Detail3;

      var selected = this.state.Selected;
      if (!selected || !((_selected$Detail2 = selected.Detail) === null || _selected$Detail2 === void 0 ? void 0 : _selected$Detail2.MaterialList)) return;
      var groupName = m.MaterialFileName;
      var displayName = m.MaterialFileName.split(".sg")[0];
      var groupMaterial = new UploadGroupMaterialsInstanceModel();
      groupMaterial.SessionId = selected.SessionId;
      groupMaterial.MaterialFileName = groupName;
      groupMaterial.DisplayFileName = displayName;
      var includes = m.UploadMaterialsItemNames;
      var id = 0;
      (_selected$Detail3 = selected.Detail) === null || _selected$Detail3 === void 0 ? void 0 : _selected$Detail3.MaterialList.filter(function (m) {
        return m.Is3D && m.MaterialFileExtension.toLowerCase() != ".sg";
      }).forEach(function (m) {
        var _ref2;

        var groupMaterialsItem = new UploadGroupMaterialsItemInstanceModel();
        groupMaterialsItem.SessionId = groupMaterial.SessionId;
        groupMaterialsItem.MaterialFileName = groupMaterial.MaterialFileName;
        groupMaterialsItem.ItemId = id;
        groupMaterialsItem.ItemName = m.MaterialFileName;
        groupMaterialsItem.LastModified = m.LastModified;
        groupMaterialsItem.Included = (_ref2 = (includes === null || includes === void 0 ? void 0 : includes.indexOf(m.MaterialFileName)) !== -1) !== null && _ref2 !== void 0 ? _ref2 : false;

        if (!groupMaterial.Items) {
          groupMaterial.Items = [];
        }

        groupMaterial.Items.push(groupMaterialsItem);
        id++;
      });

      if (selected) {
        selected.SelectedGroupMaterial = groupMaterial;
      }

      this.setState({
        IsProcessing: true,
        ErrorMessages: [],
        SessionGroupMaterialModalMode: SessionGroupMaterialModalComponent.Mode.Modify
      });
    }
    /**
     * グループを更新します。
     *
     * @param model モデル
     */

  }, {
    key: "modifyGroupMaterial",
    value: function modifyGroupMaterial(model) {
      var _this19 = this;

      var fileNameArray = [];
      model.Items.filter(function (item) {
        return item.Included;
      }).map(function (item) {
        if (item.ItemName) {
          fileNameArray.push(item.ItemName);
        }
      });
      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.ModifyMaterial(model.SessionId, model.MaterialFileName, fileNameArray, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        var selected = _this19.setDetail(data.Detail);

        _this19.updateTempValue(selected.Detail);

        _this19.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: selected
        });
      });
    }
    /**
     * グループを削除します。
     *
     * @param m モデル
     */

  }, {
    key: "deleteGroupMaterial",
    value: function deleteGroupMaterial(m) {
      var _this20 = this;

      var fileNameArray = [];
      fileNameArray.push(m.MaterialFileName);
      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.DeleteMaterial(m.SessionId, fileNameArray, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        var selected = _this20.setDetail(data.Detail);

        _this20.updateTempValue(selected.Detail);

        _this20.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: selected
        });
      });
    }
    /**
     * グループモーダルを閉じます
     */

  }, {
    key: "hiddenGroupMaterial",
    value: function hiddenGroupMaterial() {
      var _selected$Detail4;

      var selected = this.state.Selected;
      if (!selected || !((_selected$Detail4 = selected.Detail) === null || _selected$Detail4 === void 0 ? void 0 : _selected$Detail4.MaterialList)) return;

      if (selected) {
        selected.SelectedGroupMaterial = null;
      }

      this.setState({
        IsProcessing: false,
        SessionGroupMaterialModalMode: SessionGroupMaterialModalComponent.Mode.None,
        Selected: selected
      });
    }
    /**
     * ダウンロードを許可します
     *
     * @param selected 選択モデル
     */

  }, {
    key: "allowShare",
    value: function allowShare(selected) {
      var _this21 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.ShareSettingMaterial(selected.SessionId, selected.SelectedFileNames, true, selected.Detail.UpdateDateTime, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        var selected = _this21.setDetail(data.Detail);

        _this21.updateTempValue(selected.Detail);

        _this21.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: selected
        });
      });
    }
    /**
     * ダウンロードを拒否します
     *
     * @param selected 選択モデル
     */

  }, {
    key: "denyShare",
    value: function denyShare(selected) {
      var _this22 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.ShareSettingMaterial(selected.SessionId, selected.SelectedFileNames, false, selected.Detail.UpdateDateTime, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        var selected = _this22.setDetail(data.Detail);

        _this22.updateTempValue(selected.Detail);

        _this22.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: selected
        });
      });
    }
    /**
     * ダウンロード処理を行います。
     *
     * @param selected 選択モデル
     */

  }, {
    key: "download",
    value: function () {
      var _download = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var formData, controller, signal, response, _response$body, contentDisposition, fileName, _this$state$Selected, _this$state$Selected$, sessionName, now, datePart, timePart, reader, fileStream, writer;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                setTimeout(function () {
                  $("#overlay").fadeIn();
                });
                this.setState({
                  IsProcessing: true,
                  IsDownloading: true,
                  ErrorMessages: []
                });
                formData = new FormData(document.getElementById("MainForm"));
                controller = new AbortController();
                signal = controller.signal;
                _context2.prev = 5;
                _context2.next = 8;
                return fetch("/session", {
                  method: "POST",
                  body: formData,
                  signal: signal
                });

              case 8:
                response = _context2.sent;

                if (!response.ok) {
                  _context2.next = 24;
                  break;
                }

                contentDisposition = response.headers.get('Content-Disposition');
                fileName = contentDisposition === null || contentDisposition === void 0 ? void 0 : contentDisposition.split('filename=')[1].replace(/["']/g, "");

                if (!fileName) {
                  sessionName = ((_this$state$Selected = this.state.Selected) === null || _this$state$Selected === void 0 ? void 0 : (_this$state$Selected$ = _this$state$Selected.Detail) === null || _this$state$Selected$ === void 0 ? void 0 : _this$state$Selected$.SessionName) || "UnknownRoom";
                  now = new Date();
                  datePart = now.toISOString().slice(0, 10).replace(/-/g, "");
                  timePart = now.toTimeString().slice(0, 5).replace(/:/g, "");
                  fileName = "".concat(sessionName, "_").concat(datePart, "_").concat(timePart, ".zip");
                }

                fileName = decodeURIComponent(fileName);
                reader = (_response$body = response.body) === null || _response$body === void 0 ? void 0 : _response$body.getReader();

                if (reader) {
                  _context2.next = 17;
                  break;
                }

                return _context2.abrupt("return");

              case 17:
                fileStream = streamSaver.createWriteStream(fileName);
                writer = fileStream.getWriter();
                new ReadableStream({
                  start: function start(streamController) {
                    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                      var _yield$reader$read, done, value;

                      return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              _context.prev = 0;

                            case 1:
                              if (!true) {
                                _context.next = 17;
                                break;
                              }

                              _context.next = 4;
                              return reader.read();

                            case 4:
                              _yield$reader$read = _context.sent;
                              done = _yield$reader$read.done;
                              value = _yield$reader$read.value;

                              if (!done) {
                                _context.next = 11;
                                break;
                              }

                              console.log("Stream completed");
                              writer.close();
                              return _context.abrupt("break", 17);

                            case 11:
                              if (!value) {
                                _context.next = 15;
                                break;
                              }

                              _context.next = 14;
                              return writer.write(value);

                            case 14:
                              streamController.enqueue(value);

                            case 15:
                              _context.next = 1;
                              break;

                            case 17:
                              streamController.close();
                              _context.next = 25;
                              break;

                            case 20:
                              _context.prev = 20;
                              _context.t0 = _context["catch"](0);
                              console.error("Error in stream processing:", _context.t0);
                              writer.abort(_context.t0);
                              controller.abort();

                            case 25:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee, null, [[0, 20]]);
                    }))();
                  }
                });
                setTimeout(function () {
                  $("#overlay").fadeOut(300);
                }, 500);
                this.setState({
                  IsProcessing: false,
                  IsDownloading: false
                });
                _context2.next = 26;
                break;

              case 24:
                setTimeout(function () {
                  $("#overlay").fadeOut(300);
                }, 500);
                this.setState({
                  IsProcessing: false,
                  IsDownloading: false
                });

              case 26:
                _context2.next = 32;
                break;

              case 28:
                _context2.prev = 28;
                _context2.t0 = _context2["catch"](5);
                setTimeout(function () {
                  $("#overlay").fadeOut(300);
                }, 500);
                this.setState({
                  IsProcessing: false,
                  IsDownloading: false
                });

              case 32:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 28]]);
      }));

      function download() {
        return _download.apply(this, arguments);
      }

      return download;
    }()
    /**
     * 削除処理を行います。
     *
     * @param selected 選択モデル
     */

  }, {
    key: "delete",
    value: function _delete(selected) {
      var _this23 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.DeleteMaterial(selected.SessionId, selected.SelectedFileNames, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        var selected = _this23.setDetail(data.Detail);

        _this23.updateTempValue(selected.Detail);

        _this23.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: selected
        });
      });
    }
    /**
     * 素材選択変更
     *
     * @param m 素材情報
     */

  }, {
    key: "changeSelectedMaterial",
    value: function changeSelectedMaterial(m) {
      if (!this.state.Selected) {
        throw Error();
      }

      var next = this.state.Selected.SelectedFileNames.filter(function (x, _i) {
        return x != m.MaterialFileName;
      }); //前回と同じ場合は、未選択

      if (next.length == this.state.Selected.SelectedFileNames.length) {
        next.push(m.MaterialFileName);
      }

      var selected = this.state.Selected;
      selected.SelectedFileNames = next;
      this.setState({
        Selected: selected
      });
    }
    /**
     * 素材選択変更
     *
     * @param event 素材情報イベント
     */

  }, {
    key: "onRowSelected",
    value: function onRowSelected(event) {
      if (!this.state.Selected) {
        throw Error();
      }

      var selectedFileNames = [];
      var selectedRows = event.api.getSelectedRows();

      if (selectedRows.length > 0) {
        for (var i = 0; i < selectedRows.length; i++) {
          selectedFileNames.push(selectedRows[i].MaterialFileName);
        }
      }

      var selected = this.state.Selected;
      selected.SelectedFileNames = selectedFileNames;
      this.setState({
        Selected: selected
      });
    }
    /**
     * 選択中の素材が削除可能か判断します。
     */

  }, {
    key: "canDeleteMaterial",
    value: function canDeleteMaterial() {
      if (!this.state.Selected) {
        return false;
      }

      if (!this.state.Selected.IsMyMeeting) {
        return false;
      }

      if (this.state.Selected.SelectedFileNames.length == 0) {
        return false;
      }

      var result = true;

      for (var i = 0; i < this.state.Selected.Detail.MaterialList.length; i++) {
        var m = this.state.Selected.Detail.MaterialList[i];

        if (this.state.Selected.SelectedFileNames.filter(function (x, _i) {
          return x == m.MaterialFileName;
        }).length > 0) {
          if (m.Status == ReductionStatuses.Wait || m.Status == ReductionStatuses.Processing) {
            result = false;
            break;
          }
        }
      }

      return result;
    }
    /**
     * 選択中の素材がダウンロード可能か判断します。
     */

  }, {
    key: "canDownloadMaterial",
    value: function canDownloadMaterial() {
      if (!this.state.Selected) {
        return false;
      }

      if (this.state.Selected.IsOthersMeeting) return false;

      if (this.state.Selected.SelectedFileNames.length == 0) {
        return false;
      }

      var result = true;

      for (var i = 0; i < this.state.Selected.Detail.MaterialList.length; i++) {
        var m = this.state.Selected.Detail.MaterialList[i];

        if (this.state.Selected.SelectedFileNames.filter(function (x, _i) {
          return x == m.MaterialFileName;
        }).length > 0) {
          if (m.Status == ReductionStatuses.Wait || m.Status == ReductionStatuses.Processing || !this.state.Selected.IsMyMeeting && !this.state.Selected.IsOthersMeeting && !m.IsShare) {
            result = false;
            break;
          } // オーサリングアイテムは共有できない


          if (m.MaterialFileExtension.toLowerCase() == ".empty" || m.MaterialFileExtension.toLowerCase() == ".panel" || m.MaterialFileExtension.toLowerCase() == ".data" || m.MaterialFileExtension.toLowerCase() == ".portal" || m.MaterialFileExtension.toLowerCase() == ".stream" || m.MaterialFileExtension.toLowerCase() == ".sg") {
            result = false;
            break;
          }

          for (var j = 0; j < effects.length; j++) {
            var effect = "." + effects[j].toLowerCase();

            if (m.MaterialFileExtension.toLowerCase() == effect) {
              result = false;
              break;
            }
          }
        }
      }

      return result;
    }
    /**
     * 選択中の素材が共有可能か判断します。
     */

  }, {
    key: "canShareMaterial",
    value: function canShareMaterial() {
      if (!this.state.Selected) {
        return ShareActionTypes.None;
      }

      if (!this.state.Selected.IsMyMeeting) {
        return ShareActionTypes.None;
      }

      if (this.state.Selected.SelectedFileNames.length == 0) {
        return ShareActionTypes.None;
      }

      var result = ShareActionTypes.Allow;
      var shareCount = 0;
      var denyCount = 0;

      for (var i = 0; i < this.state.Selected.Detail.MaterialList.length; i++) {
        var m = this.state.Selected.Detail.MaterialList[i];

        if (this.state.Selected.SelectedFileNames.filter(function (x, _i) {
          return x == m.MaterialFileName;
        }).length > 0) {
          if (m.Status == ReductionStatuses.Wait || m.Status == ReductionStatuses.Processing) {
            result = ShareActionTypes.None;
            break;
          } // オーサリングアイテムは共有できない


          if (m.MaterialFileExtension.toLowerCase() == ".empty" || m.MaterialFileExtension.toLowerCase() == ".panel" || m.MaterialFileExtension.toLowerCase() == ".data" || m.MaterialFileExtension.toLowerCase() == ".portal" || m.MaterialFileExtension.toLowerCase() == ".stream" || m.MaterialFileExtension.toLowerCase() == ".sg") {
            result = ShareActionTypes.None;
            break;
          }

          for (var j = 0; j < effects.length; j++) {
            var effect = "." + effects[j].toLowerCase();

            if (m.MaterialFileExtension.toLowerCase() == effect) {
              result = ShareActionTypes.None;
              break;
            }
          }

          if (m.IsShare) {
            shareCount++;
          } else {
            denyCount++;
          }
        }
      }

      if (result != ShareActionTypes.None) {
        if (shareCount == 0 && denyCount > 0) {
          result = ShareActionTypes.Allow;
        } else if (shareCount > 0 && denyCount == 0) {
          result = ShareActionTypes.Deny;
        } else {
          result = ShareActionTypes.Allow;
        }
      }

      return result;
    }
    /**
     * 選択中の素材がグループ化可能か判断します。
     */

  }, {
    key: "canGroupMaterial",
    value: function canGroupMaterial() {
      if (!this.state.Selected) {
        return false;
      }

      if (this.state.Selected.IsOthersMeeting) return false;

      if (this.state.Selected.SelectedFileNames.length < 2) {
        return false;
      }

      var result = true;

      for (var i = 0; i < this.state.Selected.Detail.MaterialList.length; i++) {
        var m = this.state.Selected.Detail.MaterialList[i];

        if (this.state.Selected.SelectedFileNames.filter(function (x, _i) {
          return x == m.MaterialFileName;
        }).length > 0) {
          if (m.Status == ReductionStatuses.Wait || m.Status == ReductionStatuses.Processing) {
            result = false;
            break;
          }

          if (!m.Is3D) {
            result = false;
            break;
          }
        }
      }

      return result;
    }
    /**
     * リダクションステータスのアイコンを戻します。
     *
     * @param status リダクションステータス
     * @param reductionStatusConfirm リダクションステータス確認
     */

  }, {
    key: "getReductionStatusIcon",
    value: function getReductionStatusIcon(status, reductionStatusConfirm) {
      switch (status) {
        case ReductionStatuses.Failure:
        case ReductionStatuses.Cancel:
          return /*#__PURE__*/React.createElement("i", {
            className: "nav-icon fa fa-times-circle"
          });

        case ReductionStatuses.Wait:
        case ReductionStatuses.Processing:
          return /*#__PURE__*/React.createElement("i", {
            className: "nav-icon fa fa-refresh fa-spin"
          });

        case ReductionStatuses.Untreated:
          return /*#__PURE__*/React.createElement("i", {
            className: "nav-icon fa"
          });

        case ReductionStatuses.Success:
          if (reductionStatusConfirm) {
            return /*#__PURE__*/React.createElement("i", {
              className: "nav-icon fa"
            });
          } else {
            return /*#__PURE__*/React.createElement("i", {
              className: "nav-icon fa"
            });
          }

        default:
          throw Error();
      }
    }
    /**
     * ナビアイテムのクラス名を戻します。
     *
     * @param status リダクションステータス
     */

  }, {
    key: "getNavItemClassName",
    value: function getNavItemClassName(status, reductionStatusConfirm) {
      switch (status) {
        case ReductionStatuses.Cancel:
          return "Cancel";

        case ReductionStatuses.Failure:
          return " Failure";

        case ReductionStatuses.Wait:
        case ReductionStatuses.Processing:
          return " NonSuccess";

        case ReductionStatuses.Untreated:
          return " Untreated";

        case ReductionStatuses.Success:
          if (reductionStatusConfirm) {
            return " NonSuccess";
          } else {
            return "";
          }

        default:
          throw Error();
      }
    }
    /**
     * サイドバーの会議を戻します。
     *
     * @param MeetingList 会議リスト
     * @param isMyMeeting My Meetingかどうかを表す値
     * @param isOthersMeeting Others Meetingかどうかを表す値
     */

  }, {
    key: "getMeetings",
    value: function getMeetings(MeetingList, isMyMeeting, isOthersMeeting) {
      var _this24 = this;

      return /*#__PURE__*/React.createElement("ul", {
        className: "content__list"
      }, MeetingList.map(function (x, _i) {
        return /*#__PURE__*/React.createElement("li", {
          key: x.SessionId,
          className: "nav-item content__item " + (_this24.isSelected(x.SessionId) ? "content__item--active" : "") + _this24.getNavItemClassName(x.States, x.ReductionStatusConfirm)
        }, /*#__PURE__*/React.createElement("a", {
          href: "#",
          title: x.SessionName,
          className: "openSession " + (_this24.isSelected(x.SessionId) ? "selected" : ""),
          onClick: _this24.selectSession.bind(_this24, x, isMyMeeting, isOthersMeeting)
        }, /*#__PURE__*/React.createElement("p", {
          className: "inSession"
        }, x.InSession ? "●" : ""), /*#__PURE__*/React.createElement("p", null, x.SessionName)), /*#__PURE__*/React.createElement("a", {
          href: "#",
          className: "openNav nav-link" + (_this24.isSelected(x.SessionId) ? " selected" : "")
        }, _this24.getReductionStatusIcon(x.States, x.ReductionStatusConfirm)));
      }));
    }
    /**
     * DL許可の許可状態を戻します。
     *
     * @param params 許可情報
     */

  }, {
    key: "getAllowDL",
    value: function getAllowDL(params) {
      if (params.value) {
        return '<div class="dlImg"><img src="/assets/img/check_icon.svg"></div>';
      }

      return "";
    }
    /**
     * 整形された日付を取得します。
     *
     * @param date 日付
     */

  }, {
    key: "getFormattedDate",
    value: function getFormattedDate(params) {
      if (params.value) {
        return Utility.ToMoment(params.value).format("YYYY-MM-DD HH:mm:ss");
      }

      return "";
    }
    /**
     * 詳細を設定します。
     *
     * @param detail 会議詳細モデル
     */

  }, {
    key: "setDetail",
    value: function setDetail(detail) {
      if (!this.state.Selected) {
        throw Error();
      }

      var selected = this.state.Selected;
      selected.Detail = detail;
      selected.IsAllSelected = false;
      selected.SelectedFileNames = [];
      return selected;
    }
    /**
     * 一意なID生成
     */

  }, {
    key: "getGuid",
    value: function getGuid() {
      var guid = "",
          i,
          random;

      for (i = 0; i < 32; i++) {
        random = Math.random() * 16 | 0;

        if (i == 8 || i == 12 || i == 16 || i == 20) {
          guid += "-";
        }

        guid += (i == 12 ? 4 : i == 16 ? random & 3 | 8 : random).toString(16);
      }

      return guid;
    }
    /**
     * リトライ要求
     *
     * @param m 素材情報
     */

  }, {
    key: "onRequestRetry",
    value: function onRequestRetry(m) {
      var _this25 = this;

      if (!this.state.Selected) {
        throw Error();
      }

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.RequestRetry(this.state.Selected.SessionId, m.MaterialFileName, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        var selected = _this25.setDetail(data.Detail);

        _this25.updateTempValue(selected.Detail);

        _this25.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: selected
        });
      });
    }
    /**
     * キャンセル要求
     *
     * @param m 素材情報
     */

  }, {
    key: "onRequestCancel",
    value: function onRequestCancel(m) {
      var _this26 = this;

      if (!this.state.Selected) {
        throw Error();
      }

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.RequestCancel(this.state.Selected.SessionId, m.MaterialFileName, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        var selected = _this26.setDetail(data.Detail);

        _this26.updateTempValue(selected.Detail);

        _this26.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: selected
        });
      });
    }
    /**
     * セッションの履歴表示を行います。
     */

  }, {
    key: "viewSession",
    value: function viewSession() {
      if (!this.state.Selected) {
        throw Error();
      }

      $("#Action").val("ViewSession");
      $("#SessionId").val(this.state.Selected.SessionId);
      $("#MainForm").submit();
    }
    /**
     * 表示用ファイルサイズを返却します
     *
     * @param fileSize ファイルサイズ
     */

  }, {
    key: "displayFileSize",
    value: function displayFileSize(sizeInBytes) {
      var sizeInKilobytes = sizeInBytes / 1024;
      var sizeInMegabytes = sizeInKilobytes / 1024;
      var sizeInGigabytes = sizeInMegabytes / 1024;

      if (sizeInBytes < 1024) {
        return "".concat(sizeInBytes.toFixed(1), " B");
      } else if (sizeInKilobytes < 1024) {
        return "".concat(sizeInKilobytes.toFixed(1), " KB");
      } else if (sizeInMegabytes < 1024) {
        return "".concat(sizeInMegabytes.toFixed(2), " MB");
      } else {
        return "".concat(sizeInGigabytes.toFixed(2), " GB");
      }
    }
    /**
     * 「リダクション率」ボタン押下時の処理を行います。
     */

  }, {
    key: "onReductionRateDialogOpen",
    value: function onReductionRateDialogOpen(m) {
      var dialog = null;

      if (!this.state.Selected) {
        return;
      }

      dialog = $("#ReductionRateModal");

      if (dialog) {
        dialog.modal('show');
        var selected = this.state.Selected;
        selected.SelectedFileName = m.MaterialFileName;
        selected.SelectedOriginalReductionRate = m.ReductionRate ? m.ReductionRate : 0;
        selected.SelectedChangedReductionRate = m.ReductionRate ? m.ReductionRate : 0;
        this.setState({
          IsProcessing: true,
          Selected: selected
        });
      }
    }
    /**
     * リダクション率を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateReductionRate",
    value: function updateReductionRate(e) {
      if (!this.state.Selected) return;
      var selected = this.state.Selected;
      selected.SelectedChangedReductionRate = Number(e.target.value);
      this.setState({
        IsProcessing: true,
        Selected: selected
      });
    }
    /**
     * リダクション率をセットする
     */

  }, {
    key: "onSetReduction",
    value: function onSetReduction() {
      var _this27 = this;

      if (!this.state.Selected || !this.state.Selected.SelectedFileName) return;

      if (this.state.Selected.SelectedOriginalReductionRate == this.state.Selected.SelectedChangedReductionRate) {
        this.onReductionRateDialogClose();
        return;
      }

      var reductionRate = this.state.Selected.SelectedChangedReductionRate;
      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.SetReduction(this.state.Selected.SessionId, this.state.Selected.SelectedFileName, reductionRate, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        var selected = _this27.setDetail(data.Detail);

        _this27.updateTempValue(selected.Detail);

        selected.SelectedFileName = null;
        selected.SelectedOriginalReductionRate = 0;
        selected.SelectedChangedReductionRate = 0;

        _this27.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: selected
        });

        var dialog = $("#ReductionRateModal");

        if (dialog) {
          dialog.modal('hide');
        }
      });
    }
    /**
     * 「閉じる」ボタン押下時の処理を行います。
     */

  }, {
    key: "onReductionRateDialogClose",
    value: function onReductionRateDialogClose() {
      var dialog = null;
      dialog = $("#ReductionRateModal");

      if (dialog) {
        dialog.modal('hide');

        if (this.state.Selected != null) {
          var selected = this.state.Selected;
          selected.SelectedFileName = null;
          selected.SelectedOriginalReductionRate = 100;
          selected.SelectedChangedReductionRate = 100;
          this.setState({
            IsProcessing: false,
            Selected: selected
          });
        }
      }
    }
    /**
     * 表示用リダクション率を返却します
     *
     * @param reductionRate リダクション率
     */

  }, {
    key: "displayReductionRate",
    value: function displayReductionRate(reductionRate) {
      switch (reductionRate) {
        case 1:
          return intl.format(ReductionRate.OptionsHighDensity);

        default:
          return intl.format(ReductionRate.OptionsNormal);
      }
    }
    /**
     * 「再生モード」ボタン押下時の処理を行います。
     */

  }, {
    key: "onPlaybackModeDialogOpen",
    value: function onPlaybackModeDialogOpen(m) {
      var dialog = null;

      if (!this.state.Selected) {
        return;
      }

      dialog = $("#PlaybackModeModal");

      if (dialog) {
        dialog.modal('show');
        var selected = this.state.Selected;
        selected.SelectedFileName = m.MaterialFileName;
        selected.SelectedOriginalPlaybackMode = m.DisplayOptions ? m.DisplayOptions : 0;
        selected.SelectedChangedPlaybackMode = m.DisplayOptions ? m.DisplayOptions : 0;
        this.setState({
          IsProcessing: true,
          Selected: selected
        });
      }
    }
    /**
     * 再生モードを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updatePlaybackMode",
    value: function updatePlaybackMode(e) {
      if (!this.state.Selected) return;
      var selected = this.state.Selected;
      selected.SelectedChangedPlaybackMode = Number(e.target.value);
      this.setState({
        IsProcessing: true,
        Selected: selected
      });
    }
    /**
     * 再生モードをセットする
     */

  }, {
    key: "onSetPlaybackMode",
    value: function onSetPlaybackMode() {
      var _this28 = this;

      if (!this.state.Selected || !this.state.Selected.SelectedFileName) return;

      if (this.state.Selected.SelectedOriginalPlaybackMode == this.state.Selected.SelectedChangedPlaybackMode) {
        this.onPlaybackModeDialogClose();
        return;
      }

      var playbackMode = this.state.Selected.SelectedChangedPlaybackMode;
      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.SetPlaybackMode(this.state.Selected.SessionId, this.state.Selected.SelectedFileName, playbackMode, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        var selected = _this28.setDetail(data.Detail);

        _this28.updateTempValue(selected.Detail);

        selected.SelectedFileName = null;
        selected.SelectedOriginalPlaybackMode = 0;
        selected.SelectedChangedPlaybackMode = 0;

        _this28.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: selected
        });

        var dialog = $("#PlaybackModeModal");

        if (dialog) {
          dialog.modal('hide');
        }
      });
    }
    /**
     * 「閉じる」ボタン押下時の処理を行います。
     */

  }, {
    key: "onPlaybackModeDialogClose",
    value: function onPlaybackModeDialogClose() {
      var dialog = null;
      dialog = $("#PlaybackModeModal");

      if (dialog) {
        dialog.modal('hide');

        if (this.state.Selected != null) {
          var selected = this.state.Selected;
          selected.SelectedFileName = null;
          selected.SelectedOriginalPlaybackMode = 0;
          selected.SelectedChangedPlaybackMode = 0;
          this.setState({
            IsProcessing: false,
            Selected: selected
          });
        }
      }
    }
    /**
     * フィルター
     */

  }, {
    key: "callFilter",
    value: function callFilter() {
      var _this29 = this;

      var selected = this.state.Selected;
      var sessionId = this.state.Selected ? this.state.Selected.SessionId.toString() : null;
      Api.Filter(sessionId, this.state.MyExpanded, this.state.ShareExpanded, this.state.OthersExpanded, this.state.ShareExpandedOwners, this.state.OthersExpandedOwners, this.state.IncludePastMeetings, function (data) {
        _this29.setState({
          Sessions: data.Sessions,
          Selected: selected
        });
      });
    }
    /**
     *
     *
     * @param ownerId
     * @param list
     */

  }, {
    key: "toggleOwner",
    value: function toggleOwner(ownerId, list) {
      var _this30 = this;

      if (list === "share") {
        var s = new Set(this.state.ShareExpandedOwners);
        s.has(ownerId) ? s["delete"](ownerId) : s.add(ownerId);
        this.setState({
          ShareExpandedOwners: Array.from(s)
        }, function () {
          return _this30.callFilter();
        });
      } else {
        var _s = new Set(this.state.OthersExpandedOwners);

        _s.has(ownerId) ? _s["delete"](ownerId) : _s.add(ownerId);
        this.setState({
          OthersExpandedOwners: Array.from(_s)
        }, function () {
          return _this30.callFilter();
        });
      }
    }
    /**
     * 検索ワードを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateSearchWord",
    value: function updateSearchWord(e) {
      this.setState({
        SearchWord: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * 大小/全半/互換を吸収して比較しやすくする
     *
     * @param s
     */

  }, {
    key: "normalize",
    value: function normalize(s) {
      return (s !== null && s !== void 0 ? s : "").toLowerCase().normalize("NFKC").trim();
    }
    /**
     *  ルーム（配列）を検索語で絞り込み
     *
     * @param list
     */

  }, {
    key: "filterMeetings",
    value: function filterMeetings(list) {
      var _this31 = this;

      var arr = list !== null && list !== void 0 ? list : [];
      var key = this.normalize(this.state.SearchWord);
      if (!key) return arr;
      return arr.filter(function (m) {
        return _this31.normalize(m.SessionName).includes(key);
      });
    }
    /**
     * Share/Others 用：各オーナーの MeetingList を絞って、0件オーナーは隠す
     *
     * @param groups
     */

  }, {
    key: "filterGroups",
    value: function filterGroups(groups) {
      var _this32 = this;

      var gs = groups !== null && groups !== void 0 ? groups : [];
      var key = this.normalize(this.state.SearchWord);
      if (!key) return gs;
      return gs.map(function (g) {
        var _g$MeetingList;

        var filtered = _this32.filterMeetings((_g$MeetingList = g.MeetingList) !== null && _g$MeetingList !== void 0 ? _g$MeetingList : []); // スプレッドで新オブジェクトを作り、MeetingList だけ差し替え


        return _objectSpread(_objectSpread({}, g), {}, {
          MeetingList: filtered
        });
      }).filter(function (g) {
        var _g$MeetingList$length, _g$MeetingList2;

        return ((_g$MeetingList$length = (_g$MeetingList2 = g.MeetingList) === null || _g$MeetingList2 === void 0 ? void 0 : _g$MeetingList2.length) !== null && _g$MeetingList$length !== void 0 ? _g$MeetingList$length : 0) > 0;
      });
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this33 = this,
          _this$state$Selected2,
          _this$state$Selected3,
          _this$state$Selected4,
          _this$state$Selected5,
          _this$state$SearchWor,
          _this$state$Sessions$,
          _this$state$Sessions,
          _this$state$Sessions$2,
          _this$state$Sessions2,
          _this$state$Sessions$3,
          _this$state$Sessions3,
          _this$state$Sessions$4,
          _this$state$Sessions4,
          _this$state$Selected6;

      var mergedRowData = [];
      var uploadedRowData = this.state.Selected ? this.state.Selected.Detail.MaterialList : [];
      var sessionFilesState = this.state.Selected ? this.state.UploadingFiles[this.state.Selected.SessionId] : null;

      if (sessionFilesState != null) {
        var uploadingRowData = Object.values(sessionFilesState);
        mergedRowData = uploadingRowData;

        for (var i = 0; i < uploadedRowData.length; i++) {
          var item = uploadedRowData[i];
          var file = uploadingRowData.filter(function (u) {
            return u.MaterialFileName == item.MaterialFileName;
          });

          if (file == null || file.length == 0) {
            mergedRowData.push(item);
          }
        }

        mergedRowData = mergedRowData.sort(function (a, b) {
          return a.DisplayMaterialFileName.localeCompare(b.DisplayMaterialFileName);
        });
      } else {
        mergedRowData = uploadedRowData;
      }

      var StickyNoteCellRenderer = function StickyNoteCellRenderer(props) {
        if (props) {
          if (_this33.state.Selected) {
            var materials = _this33.state.Selected.Detail.MaterialList.filter(function (x, _i) {
              return x.MaterialFileName == props.value;
            });

            if (materials && materials.length > 0) {
              var material = materials[0];

              if (material.StickyNoteCount > 0) {
                return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
                  src: "/assets/img/Icon_StickyNote_Grey.svg",
                  width: "24px",
                  height: "24px"
                }), /*#__PURE__*/React.createElement("a", {
                  href: "#",
                  className: "stickynotes__link",
                  onClick: _this33.viewSession.bind(_this33),
                  title: material.StickyNoteCount.toString()
                }, material.StickyNoteCount.toString()));
              }
            }
          }
        }

        return "";
      };

      var ExtensionCellRenderer = function ExtensionCellRenderer(props) {
        if (props) {
          if (_this33.state.Selected) {
            var materials = _this33.state.Selected.Detail.MaterialList.filter(function (x, _i) {
              return x.MaterialFileName == props.value;
            });

            if (materials && materials.length > 0) {
              var material = materials[0];

              if (material.Is3D) {
                return /*#__PURE__*/React.createElement("div", null, material.MaterialFileExtension.toLowerCase(), " ", /*#__PURE__*/React.createElement("img", {
                  src: "/assets/img/Icon_360Media.svg",
                  width: "32px",
                  height: "16px"
                }));
              } else {
                return /*#__PURE__*/React.createElement("div", null, material.MaterialFileExtension.toLowerCase());
              }
            }
          }
        }

        return "";
      };

      var ReductionStatusCellRenderer = function ReductionStatusCellRenderer(props) {
        if (props) {
          if (_this33.state.Selected) {
            if (_this33.props.useLargeCapacityOption) {
              var _sessionFilesState = _this33.state.Selected ? _this33.state.UploadingFiles[_this33.state.Selected.SessionId] : null;

              if (_sessionFilesState != null) {
                var uploading = _sessionFilesState[props.value];

                if (uploading && uploading.UploadState && uploading.UploadState.LoadedSize && uploading.UploadState.TotalSize) {
                  if (uploading.UploadState.Progress < 100) {
                    return /*#__PURE__*/React.createElement("div", {
                      className: "state_processing"
                    }, intl.format(Situations.Uploading), " ", /*#__PURE__*/React.createElement("a", {
                      href: "#",
                      className: "state_link",
                      onClick: _this33.onAbortUpload.bind(_this33, props.value, uploading.UploadState),
                      title: _this33.displayFileSize(uploading.UploadState.LoadedSize) + " / " + _this33.displayFileSize(uploading.UploadState.TotalSize)
                    }, /*#__PURE__*/React.createElement("img", {
                      src: "/assets/img/Icon_Pause_Circle_Grey.svg",
                      width: "24px",
                      height: "24px"
                    })));
                  } else {
                    return /*#__PURE__*/React.createElement("div", null, intl.format(Situations.Wait));
                  }
                }
              }
            }

            var materials = _this33.state.Selected.Detail.MaterialList.filter(function (x, _i) {
              return x.MaterialFileName == props.value;
            });

            if (materials && materials.length > 0) {
              var material = materials[0];

              if (material.MaterialFileExtension.toLowerCase() == ".stream") {
                switch (material.StreamingStatus) {
                  case StreamingStatuses.Offline:
                  case StreamingStatuses.Archive:
                    return /*#__PURE__*/React.createElement("div", null, intl.format(StreamingSituations.Offline), " (", /*#__PURE__*/React.createElement("a", {
                      href: "#",
                      className: "state_link",
                      onClick: _this33.openStreamingSettingModal.bind(_this33, material),
                      title: intl.format(Situations.Success)
                    }, /*#__PURE__*/React.createElement("img", {
                      src: "/assets/img/Icon_Settings.svg",
                      style: {
                        marginBottom: "4px"
                      },
                      width: "16px",
                      height: "16px"
                    }), intl.format(Label.Setting)), ")");

                  case StreamingStatuses.Live:
                    return /*#__PURE__*/React.createElement("div", null, intl.format(StreamingSituations.Live), " (", /*#__PURE__*/React.createElement("a", {
                      href: "#",
                      className: "state_link",
                      onClick: _this33.openStreamingSettingModal.bind(_this33, material),
                      title: intl.format(Situations.Success)
                    }, /*#__PURE__*/React.createElement("img", {
                      src: "/assets/img/Icon_Settings.svg",
                      style: {
                        marginBottom: "4px"
                      },
                      width: "16px",
                      height: "16px"
                    }), intl.format(Label.Setting)), ")");

                  default:
                    return "";
                }
              } else if (material.MaterialFileExtension.toLowerCase() == ".portal") {
                return /*#__PURE__*/React.createElement("div", null, intl.format(Situations.Success), material.DisplayOptions == 1 ? " (" + intl.format(Label.PrivateMode) + ")" : "");
              } else if (material.MaterialFileExtension.toLowerCase() == ".sg") {
                return /*#__PURE__*/React.createElement("div", null, intl.format(Situations.Success), " (", /*#__PURE__*/React.createElement("a", {
                  href: "#",
                  className: "state_link",
                  onClick: _this33.openModifyGroupMaterialModal.bind(_this33, material),
                  title: intl.format(Situations.Success)
                }, /*#__PURE__*/React.createElement("img", {
                  src: "/assets/img/Icon_Settings.svg",
                  style: {
                    marginBottom: "4px"
                  },
                  width: "16px",
                  height: "16px"
                }), intl.format(Label.Setting)), ")");
              } else {
                switch (material.Status) {
                  case ReductionStatuses.Untreated:
                    return intl.format(Situations.Success);

                  case ReductionStatuses.Cancel:
                    return /*#__PURE__*/React.createElement("div", null, intl.format(Situations.Cancel), " ", /*#__PURE__*/React.createElement("a", {
                      href: "#",
                      className: "state_link",
                      onClick: _this33.onRequestRetry.bind(_this33, material),
                      title: intl.format(Action.Retry)
                    }, /*#__PURE__*/React.createElement("img", {
                      src: "/assets/img/Icon_Retry_Grey.svg",
                      width: "24px",
                      height: "24px"
                    })));

                  case ReductionStatuses.Failure:
                    return /*#__PURE__*/React.createElement("div", null, intl.format(Situations.Failure), " ", /*#__PURE__*/React.createElement("a", {
                      href: "#",
                      className: "state_link",
                      onClick: _this33.onRequestRetry.bind(_this33, material),
                      title: intl.format(Action.Retry)
                    }, /*#__PURE__*/React.createElement("img", {
                      src: "/assets/img/Icon_Retry_Grey.svg",
                      width: "24px",
                      height: "24px"
                    })));

                  case ReductionStatuses.Processing:
                    return /*#__PURE__*/React.createElement("div", {
                      className: "state_processing"
                    }, intl.format(Situations.Processing), " ", /*#__PURE__*/React.createElement("a", {
                      href: "#",
                      className: "state_link",
                      onClick: _this33.onRequestCancel.bind(_this33, material),
                      title: intl.format(Action.Cancel)
                    }, /*#__PURE__*/React.createElement("img", {
                      src: "/assets/img/Icon_Pause_Circle_Grey.svg",
                      width: "24px",
                      height: "24px"
                    })));

                  case ReductionStatuses.Success:
                    if (material.MaterialFileExtension.toLowerCase() == ".ply" || material.MaterialFileExtension.toLowerCase() == ".las" || material.MaterialFileExtension.toLowerCase() == ".laz" || material.MaterialFileExtension.toLowerCase() == ".pts" || material.MaterialFileExtension.toLowerCase() == ".e57") {
                      var _material$ReductionRa;

                      var reductionRate = (_material$ReductionRa = material.ReductionRate) !== null && _material$ReductionRa !== void 0 ? _material$ReductionRa : 0;
                      return /*#__PURE__*/React.createElement("div", null, intl.format(Situations.Success), " (", /*#__PURE__*/React.createElement("a", {
                        href: "#",
                        className: "state_link",
                        onClick: _this33.onReductionRateDialogOpen.bind(_this33, material),
                        title: intl.format(Situations.Success)
                      }, /*#__PURE__*/React.createElement("img", {
                        src: "/assets/img/Icon_Settings.svg",
                        style: {
                          marginBottom: "4px"
                        },
                        width: "16px",
                        height: "16px"
                      }), _this33.displayReductionRate(reductionRate)), ")");
                    } else if (material.MaterialFileExtension.toLowerCase() == ".mp4" || material.MaterialFileExtension.toLowerCase() == ".asf" || material.MaterialFileExtension == ".avi" || material.MaterialFileExtension.toLowerCase() == ".dv" || material.MaterialFileExtension.toLowerCase() == ".m4v" || material.MaterialFileExtension.toLowerCase() == ".mov" || material.MaterialFileExtension == ".mp4" || material.MaterialFileExtension.toLowerCase() == ".mpg" || material.MaterialFileExtension.toLowerCase() == ".mpeg" || material.MaterialFileExtension.toLowerCase() == ".ogv" || material.MaterialFileExtension == ".vp8" || material.MaterialFileExtension.toLowerCase() == ".webm" || material.MaterialFileExtension.toLowerCase() == ".wmv" || material.MaterialFileExtension.toLowerCase() == ".mp3" || material.MaterialFileExtension == ".ogg" || material.MaterialFileExtension.toLowerCase() == ".wav" || material.MaterialFileExtension.toLowerCase() == ".aiff" || material.MaterialFileExtension.toLowerCase() == ".aif" || material.MaterialFileExtension == ".mod" || material.MaterialFileExtension.toLowerCase() == ".it" || material.MaterialFileExtension.toLowerCase() == ".s3m" || material.MaterialFileExtension.toLowerCase() == ".xm" || material.MaterialFileExtension == ".m4a") {
                      return /*#__PURE__*/React.createElement("div", null, intl.format(Situations.Success), " (", /*#__PURE__*/React.createElement("a", {
                        href: "#",
                        className: "state_link",
                        onClick: _this33.onPlaybackModeDialogOpen.bind(_this33, material),
                        title: intl.format(Situations.Success)
                      }, /*#__PURE__*/React.createElement("img", {
                        src: "/assets/img/Icon_Settings.svg",
                        style: {
                          marginBottom: "4px"
                        },
                        width: "16px",
                        height: "16px"
                      }), intl.format(Label.Setting)), ")");
                    } else {
                      return intl.format(Situations.Success);
                    }

                  case ReductionStatuses.Wait:
                    return /*#__PURE__*/React.createElement("div", null, intl.format(Situations.Wait), " ", /*#__PURE__*/React.createElement("a", {
                      href: "#",
                      className: "state_link",
                      onClick: _this33.onRequestCancel.bind(_this33, material),
                      title: intl.format(Action.Cancel)
                    }, /*#__PURE__*/React.createElement("img", {
                      src: "/assets/img/Icon_Pause_Circle_Grey.svg",
                      width: "24px",
                      height: "24px"
                    })));

                  default:
                    return "";
                }
              }
            }
          }
        }

        return "";
      };

      var ReductionSizeCellRenderer = function ReductionSizeCellRenderer(props) {
        if (props) {
          if (_this33.state.Selected) {
            if (_this33.props.useLargeCapacityOption) {
              var _sessionFilesState2 = _this33.state.Selected ? _this33.state.UploadingFiles[_this33.state.Selected.SessionId] : null;

              if (_sessionFilesState2 != null) {
                var uploading = _sessionFilesState2[props.value];

                if (uploading && uploading.UploadState) {
                  return uploading.UploadState.Progress + "%";
                }
              }
            }

            var materials = _this33.state.Selected.Detail.MaterialList.filter(function (x, _i) {
              return x.MaterialFileName == props.value;
            });

            if (materials && materials.length > 0) {
              var material = materials[0];

              if (material.MaterialFileExtension.toLowerCase() == ".stream") {
                return "";
              } else if (material.MaterialFileExtension.toLowerCase() == ".mp4" || material.MaterialFileExtension.toLowerCase() == ".asf" || material.MaterialFileExtension == ".avi" || material.MaterialFileExtension.toLowerCase() == ".dv" || material.MaterialFileExtension.toLowerCase() == ".m4v" || material.MaterialFileExtension.toLowerCase() == ".mov" || material.MaterialFileExtension == ".mp4" || material.MaterialFileExtension.toLowerCase() == ".mpg" || material.MaterialFileExtension.toLowerCase() == ".mpeg" || material.MaterialFileExtension.toLowerCase() == ".ogv" || material.MaterialFileExtension == ".vp8" || material.MaterialFileExtension.toLowerCase() == ".webm" || material.MaterialFileExtension.toLowerCase() == ".wmv" || material.MaterialFileExtension.toLowerCase() == ".mp3" || material.MaterialFileExtension == ".ogg" || material.MaterialFileExtension.toLowerCase() == ".wav" || material.MaterialFileExtension.toLowerCase() == ".aiff" || material.MaterialFileExtension.toLowerCase() == ".aif" || material.MaterialFileExtension == ".mod" || material.MaterialFileExtension.toLowerCase() == ".it" || material.MaterialFileExtension.toLowerCase() == ".s3m" || material.MaterialFileExtension.toLowerCase() == ".xm" || material.MaterialFileExtension == ".m4a") {
                var _material$DisplayOpti;

                var playbackMode = (_material$DisplayOpti = material.DisplayOptions) !== null && _material$DisplayOpti !== void 0 ? _material$DisplayOpti : 0;

                switch (playbackMode) {
                  case 1:
                    return /*#__PURE__*/React.createElement("div", {
                      className: "state_label"
                    }, /*#__PURE__*/React.createElement("img", {
                      src: "/assets/img/Icon_Streaming.svg",
                      width: "24px",
                      height: "24px"
                    }), intl.format(PlaybackMode.Streaming));

                  default:
                    if (material.Status == ReductionStatuses.Success) {
                      var _material$ReductionMa;

                      return _this33.displayFileSize(((_material$ReductionMa = material.ReductionMaterialFileSize) !== null && _material$ReductionMa !== void 0 ? _material$ReductionMa : 0) * 1024);
                    }

                    return _this33.displayFileSize(material.MaterialFileSize * 1024);
                }
              } else if (material.MaterialFileExtension.toLowerCase() == ".sg") {
                var count = material.UploadMaterialsItemNames ? material.UploadMaterialsItemNames.length : 0;
                return intl.format(Label.Files, {
                  count: count
                });
              } else {
                if (material.Status == ReductionStatuses.Success) {
                  var _material$ReductionMa2;

                  return _this33.displayFileSize(((_material$ReductionMa2 = material.ReductionMaterialFileSize) !== null && _material$ReductionMa2 !== void 0 ? _material$ReductionMa2 : 0) * 1024);
                } else {
                  return _this33.displayFileSize(material.MaterialFileSize * 1024);
                }
              }
            }
          }
        }

        return "";
      };

      return /*#__PURE__*/React.createElement("div", {
        className: "content-container"
      }, /*#__PURE__*/React.createElement("div", {
        id: "overlay"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cv-spinner"
      }, /*#__PURE__*/React.createElement("span", {
        className: "spinner"
      }))), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "Action",
        id: "Action",
        value: "DownloadMaterial"
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        id: "sessionId",
        name: "sessionId",
        value: (_this$state$Selected2 = this.state.Selected) === null || _this$state$Selected2 === void 0 ? void 0 : _this$state$Selected2.SessionId
      }), /*#__PURE__*/React.createElement("input", {
        type: "file",
        name: "UploadMaterial",
        id: "UploadMaterial",
        multiple: true
      }), this.state.Selected && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        id: "isOver",
        name: "isOver",
        value: this.state.Selected.IsOver.toString()
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        id: "updateDateTime",
        name: "updateDateTime",
        value: this.state.Selected.Detail.UpdateDateTime
      }), this.state.Selected.SelectedFileNames.map(function (x, i) {
        return /*#__PURE__*/React.createElement("input", {
          type: "hidden",
          key: "FileNameArray[" + i + "]",
          name: "FileNameArray[" + i + "]",
          value: x
        });
      })), /*#__PURE__*/React.createElement("div", {
        className: "main newdesign"
      }, /*#__PURE__*/React.createElement("div", {
        className: "main__wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu " + (((_this$state$Selected3 = this.state.Selected) === null || _this$state$Selected3 === void 0 ? void 0 : _this$state$Selected3.IsHistory) ? "textAlign-WebKitCenter" : ""),
        id: "menuCont"
      }, (!((_this$state$Selected4 = this.state.Selected) === null || _this$state$Selected4 === void 0 ? void 0 : _this$state$Selected4.IsHistory) || ((_this$state$Selected5 = this.state.Selected) === null || _this$state$Selected5 === void 0 ? void 0 : _this$state$Selected5.IsHistory) && this.state.IncludePastMeetings) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "addMeeting",
        key: "add-btn"
      }, /*#__PURE__*/React.createElement("div", {
        className: "addMeeting__text"
      }, intl.format(Session.Title)), /*#__PURE__*/React.createElement("div", {
        className: "addMeeting__img"
      }, this.state.Sessions && this.state.Sessions.CurrentUserAuthorityId != 5 && /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: this.openAddSessionModal.bind(this),
        tabIndex: -1,
        title: "Add new room"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/add_icon.svg"
      })))), /*#__PURE__*/React.createElement("hr", {
        className: "accordion-hr"
      }), /*#__PURE__*/React.createElement("div", {
        className: "accordion-margin"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "accordion-keyword",
        maxLength: 100,
        onChange: function onChange(e) {
          return _this33.updateSearchWord(e);
        },
        value: (_this$state$SearchWor = this.state.SearchWord) !== null && _this$state$SearchWor !== void 0 ? _this$state$SearchWor : "",
        placeholder: intl.format(Label.RoomName)
      })), this.state.Sessions != null && (this.state.Sessions.CurrentUserAuthorityId == 1 || this.state.Sessions.CurrentUserAuthorityId == 2 || this.state.Sessions.CurrentUserAuthorityId == 6) && /*#__PURE__*/React.createElement("div", {
        className: "accordion-margin"
      }, /*#__PURE__*/React.createElement("div", {
        className: "checkbox icheck-asbestos"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "includePastMeetings",
        name: "includePastMeetings",
        checked: this.state.IncludePastMeetings,
        onChange: function onChange(e) {
          return _this33.setState({
            IncludePastMeetings: e.target.checked
          }, function () {
            return _this33.callFilter();
          });
        }
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: "includePastMeetings",
        className: "accordion-checkboxlabel"
      }, intl.format(Sessions.IncludePastMeetings)))), /*#__PURE__*/React.createElement("hr", {
        className: "accordion-hr"
      }), /*#__PURE__*/React.createElement("div", {
        className: "accordion-section",
        key: "my-meetings"
      }, /*#__PURE__*/React.createElement("div", {
        className: "accordion-header",
        onClick: function onClick() {
          return _this33.setState({
            MyExpanded: !_this33.state.MyExpanded
          }, function () {
            return _this33.callFilter();
          });
        }
      }, /*#__PURE__*/React.createElement("span", null, intl.format(Sessions.MyMeeting)), /*#__PURE__*/React.createElement("span", {
        className: "arrow"
      }, this.state.MyExpanded ? "▲" : "▼")), this.state.MyExpanded && this.filterMeetings((_this$state$Sessions$ = (_this$state$Sessions = this.state.Sessions) === null || _this$state$Sessions === void 0 ? void 0 : _this$state$Sessions.MyMeetingList) !== null && _this$state$Sessions$ !== void 0 ? _this$state$Sessions$ : []).length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("hr", {
        className: "accordion-hr"
      }), /*#__PURE__*/React.createElement("div", {
        className: "accordion-body"
      }, this.getMeetings(this.filterMeetings((_this$state$Sessions$2 = (_this$state$Sessions2 = this.state.Sessions) === null || _this$state$Sessions2 === void 0 ? void 0 : _this$state$Sessions2.MyMeetingList) !== null && _this$state$Sessions$2 !== void 0 ? _this$state$Sessions$2 : []), true, false)))), /*#__PURE__*/React.createElement("hr", {
        className: "accordion-hr"
      }), /*#__PURE__*/React.createElement("div", {
        className: "accordion-section",
        key: "share-meetings"
      }, /*#__PURE__*/React.createElement("div", {
        className: "accordion-header",
        onClick: function onClick() {
          return _this33.setState({
            ShareExpanded: !_this33.state.ShareExpanded
          }, function () {
            return _this33.callFilter();
          });
        }
      }, /*#__PURE__*/React.createElement("span", null, intl.format(Sessions.ShareMeeting)), /*#__PURE__*/React.createElement("span", {
        className: "arrow"
      }, this.state.ShareExpanded ? "▲" : "▼")), this.state.ShareExpanded && /*#__PURE__*/React.createElement("div", {
        className: "accordion-body"
      }, this.filterGroups((_this$state$Sessions$3 = (_this$state$Sessions3 = this.state.Sessions) === null || _this$state$Sessions3 === void 0 ? void 0 : _this$state$Sessions3.ShareMeetingList) !== null && _this$state$Sessions$3 !== void 0 ? _this$state$Sessions$3 : []).map(function (group) {
        var isExpanded = _this33.state.ShareExpandedOwners.includes(group.Owner);

        return [/*#__PURE__*/React.createElement("hr", {
          className: "accordion-hr"
        }), /*#__PURE__*/React.createElement("div", {
          className: "accordion-owner",
          key: group.Owner
        }, /*#__PURE__*/React.createElement("div", {
          className: "accordion-owner-header",
          onClick: function onClick() {
            return _this33.toggleOwner(group.Owner, "share");
          }
        }, /*#__PURE__*/React.createElement("span", {
          className: "name"
        }, group.OwnerName), /*#__PURE__*/React.createElement("span", {
          className: "arrow"
        }, isExpanded ? "▲" : "▼")), isExpanded && [/*#__PURE__*/React.createElement("hr", {
          className: "accordion-hr"
        }), /*#__PURE__*/React.createElement("div", {
          className: "accordion-owner-body"
        }, _this33.getMeetings(group.MeetingList, false, false))])];
      }))), this.state.Sessions != null && (this.state.Sessions.CurrentUserAuthorityId == 1 || this.state.Sessions.CurrentUserAuthorityId == 2 || this.state.Sessions.CurrentUserAuthorityId == 6) && [/*#__PURE__*/React.createElement("hr", {
        className: "accordion-hr"
      }), /*#__PURE__*/React.createElement("div", {
        className: "accordion-section",
        key: "others-meetings"
      }, /*#__PURE__*/React.createElement("div", {
        className: "accordion-header",
        onClick: function onClick() {
          return _this33.setState({
            OthersExpanded: !_this33.state.OthersExpanded
          }, function () {
            return _this33.callFilter();
          });
        }
      }, /*#__PURE__*/React.createElement("span", null, intl.format(Sessions.OthersMeeting)), /*#__PURE__*/React.createElement("span", {
        className: "arrow"
      }, this.state.OthersExpanded ? "▲" : "▼")), this.state.OthersExpanded && /*#__PURE__*/React.createElement("div", {
        className: "accordion-body"
      }, this.filterGroups((_this$state$Sessions$4 = (_this$state$Sessions4 = this.state.Sessions) === null || _this$state$Sessions4 === void 0 ? void 0 : _this$state$Sessions4.OthersMeetingList) !== null && _this$state$Sessions$4 !== void 0 ? _this$state$Sessions$4 : []).map(function (group) {
        var isExpanded = _this33.state.OthersExpandedOwners.includes(group.Owner);

        return [/*#__PURE__*/React.createElement("hr", {
          className: "accordion-hr"
        }), /*#__PURE__*/React.createElement("div", {
          className: "accordion-owner",
          key: group.Owner
        }, /*#__PURE__*/React.createElement("div", {
          className: "accordion-owner-header",
          onClick: function onClick() {
            return _this33.toggleOwner(group.Owner, "others");
          }
        }, /*#__PURE__*/React.createElement("span", {
          className: "name"
        }, group.OwnerName), /*#__PURE__*/React.createElement("span", {
          className: "arrow"
        }, isExpanded ? "▲" : "▼")), isExpanded && [/*#__PURE__*/React.createElement("hr", {
          className: "accordion-hr"
        }), /*#__PURE__*/React.createElement("div", {
          className: "accordion-owner-body"
        }, _this33.getMeetings(group.MeetingList, false, true))])];
      })))], /*#__PURE__*/React.createElement("hr", {
        className: "accordion-hr"
      })), ((_this$state$Selected6 = this.state.Selected) === null || _this$state$Selected6 === void 0 ? void 0 : _this$state$Selected6.IsHistory) && !this.state.IncludePastMeetings && /*#__PURE__*/React.createElement("a", {
        href: "/SessionHistory",
        id: "SessionHistoryLink"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "mainContentHeader__btn mainContentHeader__btn--hasMargin imgAndTextBtn"
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg mainContentHeader__btnImg--pc"
      }, /*#__PURE__*/React.createElement("img", {
        style: {
          width: 20,
          height: 20
        },
        src: "/assets/img/Icon_Back.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__btnText"
      }, intl.format(Action.ReturnSessionHistory))))), !(this.state.Sessions && this.state.Selected) && /*#__PURE__*/React.createElement("div", {
        style: {
          zIndex: 80,
          width: "100%",
          height: "100%"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: "1.0rem",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          opacity: 0.5
        }
      }, /*#__PURE__*/React.createElement("div", null, intl.format(Sessions.NoRoomSelected)))), this.state.Sessions && this.state.Selected && /*#__PURE__*/React.createElement("div", {
        className: "mainContent"
      }, /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader"
      }, this.state.Selected.IsMyMeeting && (!this.state.Selected.IsHistory || this.state.Selected.IsHistory && !this.state.Selected.IsOver) && /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__titleWrapper",
        title: this.state.Selected.Detail.SessionName,
        onClick: this.openModifySessionModal.bind(this)
      }, /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__titleImg mainContentHeader__contImg mainContentHeader__contImg--title"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Calender.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__dateTextWrapper mainContentHeader__contTextWrapper"
      }, /*#__PURE__*/React.createElement("div", {
        title: this.state.Selected.Detail.SessionName,
        className: "mainContentHeader__contTextFirst mainContentHeader__contSessionName"
      }, this.state.Selected.Detail.SessionName), !Utility.IsSpecifyPeriodDate(this.state.Selected.Detail.EndDateTime) && /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__contTextSecond"
      }, /*#__PURE__*/React.createElement("span", {
        className: "mainContentHeader__contSessionDate"
      }, Utility.ToMoment(this.state.Selected.Detail.StartDateTime).format("YYYY/MM/DD HH:mm"), " ~ ", intl.format(Label.IndefiniteDuration)), "\u3000", /*#__PURE__*/React.createElement("span", {
        className: "mainContentHeader__contSessionOthers"
      }, intl.format(Label.LastSaveDate), ":", this.state.Selected.Detail.LastSaveDateTime != null ? Utility.ToMoment(this.state.Selected.Detail.LastSaveDateTime).format("YYYY/MM/DD HH:mm") : "-")), Utility.IsSpecifyPeriodDate(this.state.Selected.Detail.EndDateTime) && /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__contTextSecond"
      }, /*#__PURE__*/React.createElement("span", {
        className: "mainContentHeader__contSessionDate"
      }, Utility.ToMoment(this.state.Selected.Detail.StartDateTime).format("YYYY/MM/DD HH:mm"), " ~ ", Utility.ToMoment(this.state.Selected.Detail.EndDateTime).format("YYYY/MM/DD HH:mm")), "\u3000", /*#__PURE__*/React.createElement("span", {
        className: "mainContentHeader__contSessionOthers"
      }, intl.format(Label.LastSaveDate), ":", this.state.Selected.Detail.LastSaveDateTime != null ? Utility.ToMoment(this.state.Selected.Detail.LastSaveDateTime).format("YYYY/MM/DD HH:mm") : "-"))), /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__titleImg mainContentHeader__contImg mainContentHeader__contImg--title mainContentHeader__contImg--title--edit"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Edit_Grey.svg"
      }))), (!this.state.Selected.IsMyMeeting || this.state.Selected.IsHistory && this.state.Selected.IsOver) && /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__titleWrapper",
        title: this.state.Selected.Detail.SessionName,
        onClick: this.openReadonlySessionModal.bind(this)
      }, /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__titleImg mainContentHeader__contImg mainContentHeader__contImg--title"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Calender.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__dateTextWrapper mainContentHeader__contTextWrapper"
      }, /*#__PURE__*/React.createElement("div", {
        title: this.state.Selected.Detail.SessionName,
        className: "mainContentHeader__contTextFirst mainContentHeader__contSessionName"
      }, this.state.Selected.Detail.SessionName), !Utility.IsSpecifyPeriodDate(this.state.Selected.Detail.EndDateTime) && /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__contTextSecond"
      }, /*#__PURE__*/React.createElement("span", {
        className: "mainContentHeader__contSessionDate"
      }, Utility.ToMoment(this.state.Selected.Detail.StartDateTime).format("YYYY/MM/DD HH:mm"), " ~ ", intl.format(Label.IndefiniteDuration)), "\u3000", /*#__PURE__*/React.createElement("span", {
        className: "mainContentHeader__contSessionOthers"
      }, intl.format(Label.LastSaveDate), ":", this.state.Selected.Detail.LastSaveDateTime != null ? Utility.ToMoment(this.state.Selected.Detail.LastSaveDateTime).format("YYYY/MM/DD HH:mm") : "-")), Utility.IsSpecifyPeriodDate(this.state.Selected.Detail.EndDateTime) && /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__contTextSecond"
      }, /*#__PURE__*/React.createElement("span", {
        className: "mainContentHeader__contSessionDate"
      }, Utility.ToMoment(this.state.Selected.Detail.StartDateTime).format("YYYY/MM/DD HH:mm"), " ~ ", Utility.ToMoment(this.state.Selected.Detail.EndDateTime).format("YYYY/MM/DD HH:mm")), "\u3000", /*#__PURE__*/React.createElement("span", {
        className: "mainContentHeader__contSessionOthers"
      }, intl.format(Label.LastSaveDate), ":", this.state.Selected.Detail.LastSaveDateTime != null ? Utility.ToMoment(this.state.Selected.Detail.LastSaveDateTime).format("YYYY/MM/DD HH:mm") : "-"))), /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__titleImg mainContentHeader__contImg mainContentHeader__contImg--title mainContentHeader__contImg--title--edit"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Edit_Grey.svg"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__state"
      }, this.state.Selected.IsMyMeeting && (!this.state.Selected.IsHistory || this.state.Selected.IsHistory && !this.state.Selected.IsOver) && /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__memberWrapper mainContentHeader__cont",
        onClick: this.openModifyMemberModal.bind(this)
      }, /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__memberImg mainContentHeader__contImg mainContentHeader__contImg--member"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Member.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__memberTextWrapper mainContentHeader__contTextWrapper"
      }, /*#__PURE__*/React.createElement("div", {
        title: this.state.Selected.Detail.OwnerName,
        className: "mainContentHeader__contTextFirst overflow"
      }, intl.format(Sessions.Organizer, {
        name: this.state.Selected.Detail.OwnerName
      })), /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__contTextSecond"
      }, intl.format(Sessions.Paticipant, {
        count: this.state.Selected.Detail.TargetCount
      }))), /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__memberImg mainContentHeader__contImg mainContentHeader__contImg--member mainContentHeader__contImg--member--edit"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Edit_Grey.svg"
      }))), (!this.state.Selected.IsMyMeeting || this.state.Selected.IsHistory && this.state.Selected.IsOver) && /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__memberWrapper mainContentHeader__cont",
        onClick: this.openReadonlyMemberModal.bind(this)
      }, /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__memberImg mainContentHeader__contImg mainContentHeader__contImg--member"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Member.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__memberTextWrapper mainContentHeader__contTextWrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__contTextFirst overflow"
      }, intl.format(Sessions.Organizer, {
        name: this.state.Selected.Detail.OwnerName
      })), /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__contTextSecond"
      }, intl.format(Sessions.Paticipant, {
        count: this.state.Selected.Detail.TargetCount
      }))), /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__memberImg mainContentHeader__contImg mainContentHeader__contImg--member mainContentHeader__contImg--member--edit"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Edit_Grey.svg"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__btns"
      }, (!this.state.Selected.IsHistory || this.state.Selected.IsHistory && !this.state.Selected.IsOver) && !this.state.Selected.IsHistory && !this.state.Selected.IsOthersMeeting && /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: this.openQrCodeModal.bind(this)
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "mainContentHeader__btn imgAndTextBtn"
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Arrow_White.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__btnText"
      }, intl.format(Sessions.JoinFromQRCode))))))), /*#__PURE__*/React.createElement("div", {
        className: "mainTools"
      }, /*#__PURE__*/React.createElement("div", {
        className: "mainTools__btnWrapper"
      }, !this.state.Selected.IsOthersMeeting && (!this.state.Selected.IsHistory || this.state.Selected.IsHistory && !this.state.Selected.IsOver) && /*#__PURE__*/React.createElement("a", {
        href: "#",
        "data-toggle": "modal",
        "data-target": "#ResourceUploadModal"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "mainTools__btn imgAndTextBtn"
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg mainTools__btnImg--mini"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Add.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Sessions.ToolsAddFile)))), (this.state.Selected.IsOthersMeeting || this.state.Selected.IsHistory && this.state.Selected.IsOver) && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "mainTools__btn imgAndTextBtn imgAndTextBtn--inactive"
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg mainTools__btnImg--mini"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Add.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Sessions.ToolsAddFile))), this.state.Selected.IsMyMeeting && this.canDeleteMaterial() && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "mainTools__btn imgAndTextBtn imgAndTextBtn",
        onClick: this["delete"].bind(this, this.state.Selected)
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg mainTools__btnImg--mini"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/delete_icon.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Sessions.ToolsDelete))), this.state.Selected.IsMyMeeting && !this.canDeleteMaterial() && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "mainTools__btn imgAndTextBtn imgAndTextBtn--inactive"
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg mainTools__btnImg--mini"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/delete_icon.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Sessions.ToolsDelete))), this.state.Selected.IsMyMeeting && this.canDownloadMaterial() && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "mainTools__btn imgAndTextBtn imgAndTextBtn",
        style: {
          width: "100px"
        },
        onClick: this.download.bind(this, this.state.Selected)
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg mainTools__btnImg--mini"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/download_icon.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, this.state.IsDownloading ? intl.format(Sessions.ToolsDownloading) : intl.format(Sessions.ToolsDownload))), this.state.Selected.IsMyMeeting && !this.canDownloadMaterial() && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "mainTools__btn imgAndTextBtn imgAndTextBtn--inactive",
        style: {
          width: "100px"
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg mainTools__btnImg--mini"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/download_icon.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Sessions.ToolsDownload))), !this.state.Selected.IsMyMeeting && this.canDownloadMaterial() && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "mainTools__btn imgAndTextBtn imgAndTextBtn",
        onClick: this.download.bind(this, this.state.Selected)
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg mainTools__btnImg--mini"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/download_icon.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Sessions.ToolsDownload))), !this.state.Selected.IsMyMeeting && !this.canDownloadMaterial() && /*#__PURE__*/React.createElement("div", {
        className: "mainTools__download__frame"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "mainTools__download__button mainTools__btn imgAndTextBtn imgAndTextBtn--inactive"
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg mainTools__btnImg--mini"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/download_icon.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Sessions.ToolsDownload))), /*#__PURE__*/React.createElement("div", {
        className: "mainTools__download__message"
      }, intl.format(Sessions.ToolsDownloadDescription))), this.state.Selected.IsMyMeeting && this.canShareMaterial() == ShareActionTypes.Allow && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "mainTools__btn imgAndTextBtn imgAndTextBtn",
        onClick: this.allowShare.bind(this, this.state.Selected)
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg mainTools__btnImg"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_AllowDownload.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Sessions.ToolsAllowDL))), this.state.Selected.IsMyMeeting && this.canShareMaterial() == ShareActionTypes.Deny && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "mainTools__btn imgAndTextBtn imgAndTextBtn",
        onClick: this.denyShare.bind(this, this.state.Selected)
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg mainTools__btnImg"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_ProhibitDownload.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Sessions.ToolsDenyDL))), this.state.Selected.IsMyMeeting && this.canShareMaterial() == ShareActionTypes.None && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "mainTools__btn imgAndTextBtn imgAndTextBtn--inactive"
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg mainTools__btnImg"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_AllowDownload.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Sessions.ToolsAllowDL))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "mainTools__btn imgAndTextBtn",
        onClick: this.openMaterialHistoryModal.bind(this)
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg mainTools__btnImg"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/assethistory_icon.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Sessions.ToolsChangeLog))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "mainTools__btn imgAndTextBtn",
        onClick: this.openAuthoringModal.bind(this)
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg mainTools__btnImg"
      }, /*#__PURE__*/React.createElement("img", {
        style: {
          height: "16px"
        },
        src: "/assets/img/Icon_Authoring.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Sessions.ToolsAuthoring))), this.canGroupMaterial() && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "mainTools__btn imgAndTextBtn",
        onClick: this.openAddGroupMaterialModal.bind(this)
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg mainTools__btnImg"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_SphereGroup.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Sessions.ToolsGrouping))), !this.canGroupMaterial() && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "mainTools__btn imgAndTextBtn imgAndTextBtn--inactive"
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg mainTools__btnImg"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_SphereGroup.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Sessions.ToolsGrouping)))), /*#__PURE__*/React.createElement("div", {
        className: "mainTools__capacityWrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "mainTools__capacityTextWrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "mainTools__capacityTextFirst"
      }, /*#__PURE__*/React.createElement("a", {
        href: "#",
        className: "qrplacement_link",
        onClick: this.openSessionOffsetModal.bind(this),
        title: intl.format(Sessions.PlaceByQRCode)
      }, intl.format(Sessions.PlaceByQRCode))), /*#__PURE__*/React.createElement("div", {
        className: "mainTools__capacityTextSecond"
      }, intl.format(Label.Total), " : ", this.displayFileSize(totalAvatarFileSize + totalMaterialFileSize))))), this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "grid"
      }, mergedRowData.length == 0 && /*#__PURE__*/React.createElement("div", {
        style: {
          zIndex: 80,
          width: "100%",
          height: "100%"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: "1.0rem",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          opacity: 0.5
        }
      }, /*#__PURE__*/React.createElement("div", null, intl.format(Sessions.NoFiles)))), mergedRowData.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "ag-theme-alpine"
      }, /*#__PURE__*/React.createElement(AgGridReact, {
        rowData: mergedRowData,
        defaultColDef: {
          minWidth: 100,
          lockPosition: true,
          resizable: false
        },
        rowHeight: 32,
        headerHeight: 32,
        onRowSelected: this.onRowSelected.bind(this),
        suppressRowClickSelection: true,
        suppressNoRowsOverlay: true,
        rowSelection: "multiple",
        rowClass: "my-row"
      }, /*#__PURE__*/React.createElement(AgGridColumn, {
        field: "DisplayMaterialFileName",
        headerName: intl.format(Label.Name),
        headerCheckboxSelection: true,
        checkboxSelection: true,
        minWidth: 120,
        flex: 1
      }), /*#__PURE__*/React.createElement(AgGridColumn, {
        field: "MaterialFileName",
        headerName: "",
        width: 40,
        cellRendererFramework: StickyNoteCellRenderer
      }), /*#__PURE__*/React.createElement(AgGridColumn, {
        field: "IsShare",
        headerName: intl.format(Label.Share),
        width: 80,
        cellRenderer: this.getAllowDL.bind(this)
      }), /*#__PURE__*/React.createElement(AgGridColumn, {
        field: "LastModified",
        headerName: intl.format(Label.LastModified),
        width: 195,
        valueFormatter: this.getFormattedDate.bind(this)
      }), /*#__PURE__*/React.createElement(AgGridColumn, {
        field: "MaterialFileName",
        headerName: intl.format(Label.Extension),
        width: 80,
        cellRendererFramework: ExtensionCellRenderer
      }), /*#__PURE__*/React.createElement(AgGridColumn, {
        field: "MaterialFileName",
        headerName: intl.format(Label.Status),
        width: 130,
        cellRendererFramework: ReductionStatusCellRenderer
      }), /*#__PURE__*/React.createElement(AgGridColumn, {
        field: "MaterialFileName",
        headerName: intl.format(Label.Size),
        width: 120,
        cellRendererFramework: ReductionSizeCellRenderer
      }))))))), /*#__PURE__*/React.createElement("div", {
        id: "modalArea"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "ResourceUploadModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "40",
        height: "42",
        src: "/assets/img/upload_icon_gr.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(ResourceUpload.Title))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-1"
      }, /*#__PURE__*/React.createElement("div", null)), /*#__PURE__*/React.createElement("div", {
        className: "col-5 mx-auto"
      }, /*#__PURE__*/React.createElement("a", {
        className: "btn-fileupload",
        href: "#",
        onClick: this.fileupload.bind(this),
        "data-dismiss": "modal",
        title: ""
      }, intl.format(ResourceUpload.Title))), /*#__PURE__*/React.createElement("div", {
        className: "col-5 mx-auto"
      }, this.state.Selected == null || this.state.Selected.Detail == null || !this.state.Selected.Detail.UseStreamingOption && [/*#__PURE__*/React.createElement("a", {
        className: "btn-terrainupload btn-row2 btn-row2Top",
        href: "#",
        onClick: this.openTerrainModelingModal.bind(this),
        "data-dismiss": "modal",
        title: ""
      }, intl.format(Terrain.Title)), /*#__PURE__*/React.createElement("a", {
        className: "btn-portalupload btn-row2 btn-row2Bottom",
        href: "#",
        onClick: this.openPortalModal.bind(this),
        "data-dismiss": "modal",
        title: ""
      }, intl.format(Portal.Title))], this.state.Selected != null && this.state.Selected.Detail != null && this.state.Selected.Detail.UseStreamingOption && [/*#__PURE__*/React.createElement("a", {
        className: "btn-terrainupload btn-row3 btn-row3TopBottom",
        href: "#",
        onClick: this.openTerrainModelingModal.bind(this),
        "data-dismiss": "modal",
        title: ""
      }, intl.format(Terrain.Title)), /*#__PURE__*/React.createElement("a", {
        className: "btn-portalupload btn-row3 btn-row3Middle",
        href: "#",
        onClick: this.openPortalModal.bind(this),
        "data-dismiss": "modal",
        title: ""
      }, intl.format(Portal.Title)), /*#__PURE__*/React.createElement("a", {
        className: "btn-streamingupload btn-row3 btn-row3TopBottom",
        href: "#",
        onClick: this.openStreamingModal.bind(this),
        "data-dismiss": "modal",
        title: ""
      }, intl.format(Streaming.AddTitle))]), /*#__PURE__*/React.createElement("div", {
        className: "col-1"
      }, /*#__PURE__*/React.createElement("div", null))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      })))), /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "ReductionRateModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "40",
        height: "42",
        src: "/assets/img/Icon_PointCloud.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(ReductionRate.Title))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-10 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "ReductionRate"
      }, intl.format(Label.Rate)), this.state.Selected && !this.state.Selected.IsOver && !this.state.Selected.IsOthersMeeting && [/*#__PURE__*/React.createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "ReductionRate",
        name: "ReductionRate",
        onChange: this.updateReductionRate.bind(this),
        value: this.state.Selected.SelectedChangedReductionRate,
        tabIndex: 101
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, intl.format(ReductionRate.OptionsNormal)), /*#__PURE__*/React.createElement("option", {
        value: "1"
      }, intl.format(ReductionRate.OptionsHighDensity))))], this.state.Selected && (this.state.Selected.IsOver || this.state.Selected.IsOthersMeeting) && [/*#__PURE__*/React.createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "ReductionRate",
        name: "ReductionRate",
        disabled: true,
        value: this.state.Selected.SelectedChangedReductionRate,
        tabIndex: 101
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, intl.format(ReductionRate.OptionsNormal)), /*#__PURE__*/React.createElement("option", {
        value: "1"
      }, intl.format(ReductionRate.OptionsHighDensity))))])), /*#__PURE__*/React.createElement("div", {
        className: "col-10 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-tips-topics"
      }, intl.format(ReductionRate.TipsTopics))), /*#__PURE__*/React.createElement("div", {
        className: "col-10 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-tips-notes"
      }, intl.format(ReductionRate.TipsNotes_1))), /*#__PURE__*/React.createElement("div", {
        className: "col-10 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-tips-notes"
      }, intl.format(ReductionRate.TipsNotes_2))), /*#__PURE__*/React.createElement("div", {
        className: "col-10 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-tips-notes"
      }, intl.format(ReductionRate.TipsNotes_3)))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, this.state.Selected && !this.state.Selected.IsOver && !this.state.Selected.IsOthersMeeting && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onSetReduction.bind(this),
        tabIndex: -1
      }, intl.format(Action.Update)), this.state.Selected && (this.state.Selected.IsOver || this.state.Selected.IsOthersMeeting) && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onReductionRateDialogClose.bind(this),
        tabIndex: -1
      }, intl.format(Action.Close)))))), /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "PlaybackModeModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "40",
        height: "42",
        src: "/assets/img/Icon_Streaming.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(PlaybackMode.Title))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-10 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "PlaybackMode"
      }, intl.format(Label.PlaybackMode)), this.state.Selected && !this.state.Selected.IsOver && !this.state.Selected.IsOthersMeeting && [/*#__PURE__*/React.createElement("div", {
        className: "col-8"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "PlaybackMode",
        name: "PlaybackMode",
        onChange: this.updatePlaybackMode.bind(this),
        value: this.state.Selected.SelectedChangedPlaybackMode,
        tabIndex: 101
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, intl.format(PlaybackMode.DisplayDownload)), /*#__PURE__*/React.createElement("option", {
        value: "1"
      }, intl.format(PlaybackMode.DisplayStreaming))))], this.state.Selected && (this.state.Selected.IsOver || this.state.Selected.IsOthersMeeting) && [/*#__PURE__*/React.createElement("div", {
        className: "col-8"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "PlaybackMode",
        name: "PlaybackMode",
        disabled: true,
        value: this.state.Selected.SelectedChangedPlaybackMode,
        tabIndex: 101
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, intl.format(PlaybackMode.DisplayDownload)), /*#__PURE__*/React.createElement("option", {
        value: "1"
      }, intl.format(PlaybackMode.DisplayStreaming))))])), /*#__PURE__*/React.createElement("div", {
        className: "col-10 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-tips-topics"
      }, intl.format(PlaybackMode.TipsTopics)))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, this.state.Selected && !this.state.Selected.IsOver && !this.state.Selected.IsOthersMeeting && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onSetPlaybackMode.bind(this),
        tabIndex: -1
      }, intl.format(Action.Update)), this.state.Selected && (this.state.Selected.IsOver || this.state.Selected.IsOthersMeeting) && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onPlaybackModeDialogClose.bind(this),
        tabIndex: -1
      }, intl.format(Action.Close))))))), this.state.SessionModalMode == SessionModalComponent.Mode.Add && /*#__PURE__*/React.createElement(SessionModalComponent["default"], {
        mode: this.state.SessionModalMode,
        sessionId: null,
        sessionName: this.state.ModifiedSessionName ? this.state.ModifiedSessionName : "",
        startDateTime: null,
        endDateTime: null,
        startDate: this.state.ModifiedStartDate,
        startTimeHours: this.state.ModifiedStartTimeHours,
        startTimeMinutes: this.state.ModifiedStartTimeMinutes,
        endDate: this.state.ModifiedEndDate,
        endTimeHours: this.state.ModifiedEndTimeHours,
        endTimeMinutes: this.state.ModifiedEndTimeMinutes,
        defaultSceneModelName: this.props.defaultSceneModelName,
        defaultSceneImageName: this.props.defaultSceneImageName,
        sceneModelName: this.state.ModifiedScene != null ? this.state.ModifiedScene.SceneModelName : this.props.defaultSceneModelName,
        sceneImageName: this.state.ModifiedScene != null ? this.state.ModifiedScene.SceneImageName : this.props.defaultSceneImageName,
        targetFolderName: Utility.NullStringToBlank(this.state.TargetFolderName),
        specifyPeriod: this.state.ModifiedSpecifyPeriod != null ? this.state.ModifiedSpecifyPeriod : null,
        isHistory: false,
        isMyMeeting: true,
        updateDateTime: null,
        onEntry: this.entrySessionModal.bind(this),
        onModify: this.modifySessionModel.bind(this),
        onDuplicate: this.duplicateSessionModal.bind(this),
        onDelete: this.deleteSessionModal.bind(this),
        onChangeScene: this.changeSceneSessionModal.bind(this),
        onHidden: this.hiddenSessionModal.bind(this)
      }), (this.state.SessionModalMode == SessionModalComponent.Mode.Modify || this.state.SessionModalMode == SessionModalComponent.Mode.ReadOnly) && /*#__PURE__*/React.createElement(SessionModalComponent["default"], {
        mode: this.state.SessionModalMode,
        sessionId: this.state.ModifiedSessionId ? this.state.ModifiedSessionId : this.state.Selected ? this.state.Selected.SessionId : null,
        sessionName: this.state.ModifiedSessionName ? this.state.ModifiedSessionName : this.state.Selected ? this.state.Selected.Detail.SessionName : "",
        startDateTime: this.state.Selected ? this.state.Selected.Detail.StartDateTime : null,
        endDateTime: this.state.Selected ? this.state.Selected.Detail.EndDateTime : null,
        startDate: this.state.ModifiedStartDate,
        startTimeHours: this.state.ModifiedStartTimeHours,
        startTimeMinutes: this.state.ModifiedStartTimeMinutes,
        endDate: this.state.ModifiedEndDate,
        endTimeHours: this.state.ModifiedEndTimeHours,
        endTimeMinutes: this.state.ModifiedEndTimeMinutes,
        defaultSceneModelName: this.props.defaultSceneModelName,
        defaultSceneImageName: this.props.defaultSceneImageName,
        sceneModelName: this.state.ModifiedScene ? this.state.ModifiedScene.SceneModelName : this.state.Selected ? this.state.Selected.Detail.SceneModelName : this.props.defaultSceneModelName,
        sceneImageName: this.state.ModifiedScene ? this.state.ModifiedScene.SceneImageName : this.state.Selected ? this.state.Selected.Detail.SceneImageName : this.props.defaultSceneImageName,
        targetFolderName: Utility.NullStringToBlank(this.state.TargetFolderName),
        specifyPeriod: this.state.ModifiedSpecifyPeriod != null ? this.state.ModifiedSpecifyPeriod : null,
        isHistory: false,
        isMyMeeting: this.state.Selected ? this.state.Selected.IsMyMeeting : false,
        updateDateTime: this.state.Selected ? this.state.Selected.Detail.UpdateDateTime : null,
        onEntry: this.entrySessionModal.bind(this),
        onModify: this.modifySessionModel.bind(this),
        onDuplicate: this.duplicateSessionModal.bind(this),
        onDelete: this.deleteSessionModal.bind(this),
        onChangeScene: this.changeSceneSessionModal.bind(this),
        onHidden: this.hiddenSessionModal.bind(this)
      }), this.state.SessionCopyModalMode == SessionCopyModalComponent.Mode.Copy && /*#__PURE__*/React.createElement(SessionCopyModalComponent["default"], {
        mode: this.state.SessionCopyModalMode,
        sessionId: this.state.ModifiedSessionId ? this.state.ModifiedSessionId : this.state.Selected ? this.state.Selected.SessionId : null,
        sessionName: this.state.ModifiedSessionName ? this.state.ModifiedSessionName : this.state.Selected ? this.state.Selected.Detail.SessionName : "",
        startDateTime: this.state.Selected ? this.state.Selected.Detail.StartDateTime : null,
        endDateTime: this.state.Selected ? this.state.Selected.Detail.EndDateTime : null,
        startDate: this.state.ModifiedStartDate,
        startTimeHours: this.state.ModifiedStartTimeHours,
        startTimeMinutes: this.state.ModifiedStartTimeMinutes,
        endDate: this.state.ModifiedEndDate,
        endTimeHours: this.state.ModifiedEndTimeHours,
        endTimeMinutes: this.state.ModifiedEndTimeMinutes,
        defaultSceneModelName: this.props.defaultSceneModelName,
        defaultSceneImageName: this.props.defaultSceneImageName,
        sceneModelName: this.state.ModifiedScene ? this.state.ModifiedScene.SceneModelName : this.state.Selected ? this.state.Selected.Detail.SceneModelName : this.props.defaultSceneModelName,
        sceneImageName: this.state.ModifiedScene ? this.state.ModifiedScene.SceneImageName : this.state.Selected ? this.state.Selected.Detail.SceneImageName : this.props.defaultSceneImageName,
        targetFolderName: Utility.NullStringToBlank(this.state.TargetFolderName),
        specifyPeriod: this.state.ModifiedSpecifyPeriod != null ? this.state.ModifiedSpecifyPeriod : null,
        useState: this.state.ModifiedUseState != null ? this.state.ModifiedUseState : true,
        useMember: this.state.ModifiedUseMember != null ? this.state.ModifiedUseMember : true,
        isHistory: true,
        isMyMeeting: this.state.Selected ? this.state.Selected.IsMyMeeting : false,
        updateDateTime: this.state.Selected ? this.state.Selected.Detail.UpdateDateTime : null,
        onCopy: this.copySessionModal.bind(this),
        onChangeScene: this.changeSceneSessionModal.bind(this),
        onHidden: this.hiddenSessionCopyModal.bind(this)
      }), this.state.SessionCopyModalMode == SessionCopyModalComponent.Mode.CopyNew && /*#__PURE__*/React.createElement(SessionCopyModalComponent["default"], {
        mode: this.state.SessionCopyModalMode,
        sessionId: this.state.ModifiedSessionId,
        sessionName: this.state.ModifiedSessionName ? this.state.ModifiedSessionName : "",
        startDateTime: null,
        endDateTime: null,
        startDate: this.state.ModifiedStartDate,
        startTimeHours: this.state.ModifiedStartTimeHours,
        startTimeMinutes: this.state.ModifiedStartTimeMinutes,
        endDate: this.state.ModifiedEndDate,
        endTimeHours: this.state.ModifiedEndTimeHours,
        endTimeMinutes: this.state.ModifiedEndTimeMinutes,
        defaultSceneModelName: this.props.defaultSceneModelName,
        defaultSceneImageName: this.props.defaultSceneImageName,
        sceneModelName: this.state.ModifiedScene != null ? this.state.ModifiedScene.SceneModelName : this.props.defaultSceneModelName,
        sceneImageName: this.state.ModifiedScene != null ? this.state.ModifiedScene.SceneImageName : this.props.defaultSceneImageName,
        targetFolderName: Utility.NullStringToBlank(this.state.TargetFolderName),
        specifyPeriod: this.state.ModifiedSpecifyPeriod != null ? this.state.ModifiedSpecifyPeriod : null,
        useState: this.state.ModifiedUseState != null ? this.state.ModifiedUseState : false,
        useMember: this.state.ModifiedUseMember != null ? this.state.ModifiedUseMember : false,
        isHistory: false,
        isMyMeeting: this.state.Selected ? this.state.Selected.IsMyMeeting : false,
        updateDateTime: null,
        onCopy: this.copySessionModal.bind(this),
        onChangeScene: this.changeSceneSessionModal.bind(this),
        onHidden: this.hiddenSessionCopyModal.bind(this)
      }), this.state.SessionSceneModalMode != SessionSceneModalComponent.Mode.None && /*#__PURE__*/React.createElement(SessionSceneModalComponent["default"], {
        mode: this.state.SessionSceneModalMode,
        baseSessionId: this.state.ModifiedSessionId ? this.state.ModifiedSessionId : this.state.Selected ? this.state.Selected.IsOver ? this.state.Selected.SessionId : null : null,
        targetFolderName: Utility.NullStringToBlank(this.state.TargetFolderName),
        sceneModelName: this.state.ModifiedScene ? this.state.ModifiedScene.SceneModelName : this.state.Selected ? this.state.Selected.Detail.SceneModelName : this.props.defaultSceneModelName,
        sceneImageName: this.state.ModifiedScene ? this.state.ModifiedScene.SceneImageName : this.state.Selected ? this.state.Selected.Detail.SceneImageName : this.props.defaultSceneImageName,
        onDecide: this.decideSessionSceneModal.bind(this),
        onBack: this.backSessionSceneModal.bind(this),
        onHidden: this.hiddenSessionSceneModal.bind(this)
      }), this.state.SessionOffsetModalMode != SessionOffsetModalComponent.Mode.None && this.state.Selected && this.state.Sessions && /*#__PURE__*/React.createElement(SessionOffsetModalComponent["default"], {
        mode: this.state.SessionOffsetModalMode,
        onHidden: this.hiddenSessionOffsetModal.bind(this)
      }), this.state.QrCodeModalMode != QrCodeModalComponent.Mode.None && this.state.Selected && this.state.Sessions && /*#__PURE__*/React.createElement(QrCodeModalComponent["default"], {
        common: this.props.common,
        mode: this.state.QrCodeModalMode,
        roomId: this.state.Selected.Detail.RoomId,
        qrCodeSessioniOSJoinUrl: this.state.Selected.Detail.QRCodeSessioniOSJoinUrl,
        onHidden: this.hiddenQrCodeModal.bind(this)
      }), this.state.MemberModalMode != MemberModalComponent.Mode.None && this.state.Selected && this.state.Sessions && /*#__PURE__*/React.createElement(MemberModalComponent["default"], {
        mode: this.state.MemberModalMode,
        sessionId: this.state.Selected.SessionId,
        totalMaterialFileSize: totalMaterialFileSize,
        sessionStorageSize: this.props.sessionStorageSize,
        avatarStorageSize: this.props.AvatarStorageSize,
        updateDateTime: this.state.Selected.Detail.UpdateDateTime,
        sessionName: this.state.Selected.Detail.SessionName,
        ownerKey: this.state.Selected.Detail.OwnerKey,
        ownerName: this.state.Selected.Detail.OwnerName,
        onModify: this.modifyMemberModal.bind(this),
        onHidden: this.hiddenMemberModal.bind(this)
      }), this.state.TerrainModelingModalMode != TerrainModelingModalComponent.Mode.None && this.state.Selected && /*#__PURE__*/React.createElement(TerrainModelingModalComponent["default"], {
        mode: this.state.TerrainModelingModalMode,
        sessionId: this.state.Selected.SessionId,
        materialFileList: this.state.Selected.Detail.MaterialList.map(function (m) {
          return m.MaterialFileName;
        }),
        sessionStorageSize: this.props.sessionStorageSize,
        totalMaterialFileSize: totalMaterialFileSize,
        totalAvatarFileSize: totalAvatarFileSize,
        onEntry: this.entryTerrainModel.bind(this),
        onHidden: this.hiddenTerrainModelingModal.bind(this),
        defaultCenterLatitude: this.props.defaultCenterLatitude,
        defaultCenterLongitude: this.props.defaultCenterLongitude,
        defaultSelectLatitude: this.props.defaultSelectLatitude,
        defaultSelectLongitude: this.props.defaultSelectLongitude,
        defaultSelectLevel: this.props.defaultSelectLevel,
        mapZoom: this.props.defaultMapZoom,
        rectDistance: this.props.rectDistance
      }), this.state.PortalModalMode != SessionPortalModalComponent.Mode.None && this.state.Selected && /*#__PURE__*/React.createElement(SessionPortalModalComponent["default"], {
        mode: this.state.PortalModalMode,
        sessionId: this.state.Selected.SessionId,
        onEntry: this.entryPortalModel.bind(this),
        onBack: this.hiddenPortalModal.bind(this),
        onHidden: this.hiddenPortalModal.bind(this)
      }), this.state.SessionStreamingModalMode != SessionStreamingModalComponent.Mode.None && this.state.Selected && /*#__PURE__*/React.createElement(SessionStreamingModalComponent["default"], {
        mode: this.state.SessionStreamingModalMode,
        sessionId: this.state.Selected.SessionId,
        monthlyTotalUpTime: this.state.MonthlyTotalUpTime,
        monthlyLimitUpTime: this.state.MonthlyLimitUpTime,
        onEntry: this.entryStreamingModel.bind(this),
        onBack: this.hiddenStreamingModal.bind(this),
        onHidden: this.hiddenStreamingModal.bind(this)
      }), this.state.SessionStreamingSettingModalMode != SessionStreamingSettingModalComponent.Mode.None && this.state.Selected && /*#__PURE__*/React.createElement(SessionStreamingSettingModalComponent["default"], {
        mode: this.state.SessionStreamingSettingModalMode,
        sessionId: this.state.Selected.SessionId,
        streamingLocation: this.state.Selected.StreamingLocation != null ? this.state.Selected.StreamingLocation : "",
        streamingStatus: this.state.Selected.StreamingStatus != null ? this.state.Selected.StreamingStatus : StreamingStatuses.Offline,
        streamingUrl: this.state.Selected.StreamingUrl != null ? this.state.Selected.StreamingUrl : "",
        onNotify: this.notifyStreamingSettingModel.bind(this),
        onBack: this.hiddenStreamingSettingModal.bind(this),
        onHidden: this.hiddenStreamingSettingModal.bind(this)
      }), this.state.SessionActionsHistoryModalMode != SessionActionsHistoryModalComponent.Mode.None && this.state.Selected && this.state.Sessions && /*#__PURE__*/React.createElement(SessionActionsHistoryModalComponent["default"], {
        mode: this.state.SessionActionsHistoryModalMode,
        sessionId: this.state.Selected.SessionId,
        pageSize: this.props.pageSize,
        onHidden: this.hiddenMaterialHistoryModal.bind(this)
      }), this.state.SessionAuthoringMenuModalMode != SessionAuthoringMenuModalComponent.Mode.None && this.state.Selected && this.state.Sessions && /*#__PURE__*/React.createElement(SessionAuthoringMenuModalComponent["default"], {
        mode: this.state.SessionAuthoringMenuModalMode,
        sessionId: this.state.Selected.SessionId,
        onSelectMenu: this.selectMemuAuthoringMenuModal.bind(this),
        onHidden: this.hiddenAuthoringMenuModal.bind(this)
      }), this.state.SessionAuthoringModalMode != SessionAuthoringModalComponent.Mode.None && this.state.Selected && this.state.Sessions && /*#__PURE__*/React.createElement(SessionAuthoringModalComponent["default"], {
        mode: this.state.SessionAuthoringModalMode,
        authoringMode: this.state.SessionAuthoringModalAuthoringMode,
        sessionId: this.state.Selected.SessionId,
        onHidden: this.hiddenAuthoringModal.bind(this)
      }), this.state.SessionAuthoringEmptyModalMode != SessionAuthoringEmptyModalComponent.Mode.None && this.state.Selected && this.state.Sessions && /*#__PURE__*/React.createElement(SessionAuthoringEmptyModalComponent["default"], {
        mode: this.state.SessionAuthoringEmptyModalMode,
        sessionId: this.state.Selected.SessionId,
        onEntry: this.addAuthoringEmptyModal.bind(this),
        onBack: this.backAuthoringEmptyModal.bind(this),
        onHidden: this.hiddenAuthoringEmptyModal.bind(this)
      }), this.state.SessionAuthoringEffectModalMode != SessionAuthoringEffectModalComponent.Mode.None && this.state.Selected && this.state.Sessions && /*#__PURE__*/React.createElement(SessionAuthoringEffectModalComponent["default"], {
        mode: this.state.SessionAuthoringEffectModalMode,
        sessionId: this.state.Selected.SessionId,
        onEntry: this.addAuthoringEffectModal.bind(this),
        onBack: this.backAuthoringEffectModal.bind(this),
        onHidden: this.hiddenAuthoringEffectModal.bind(this)
      }), this.state.SessionAuthoringTextPanelModalMode != SessionAuthoringTextPanelModalComponent.Mode.None && this.state.Selected && this.state.Sessions && /*#__PURE__*/React.createElement(SessionAuthoringTextPanelModalComponent["default"], {
        mode: this.state.SessionAuthoringTextPanelModalMode,
        sessionId: this.state.Selected.SessionId,
        onEntry: this.addAuthoringTextPanelModal.bind(this),
        onBack: this.backAuthoringTextPanelModal.bind(this),
        onHidden: this.hiddenAuthoringTextPanelModal.bind(this)
      }), this.state.SessionAuthoringMessageModalMode != SessionAuthoringMessageModalComponent.Mode.None && this.state.Selected && this.state.Sessions && /*#__PURE__*/React.createElement(SessionAuthoringMessageModalComponent["default"], {
        mode: this.state.SessionAuthoringMessageModalMode,
        sessionId: this.state.Selected.SessionId,
        messageId: "",
        onBack: this.backAuthoringMessageModal.bind(this),
        onHidden: this.hiddenAuthoringMessageModal.bind(this)
      }), this.state.SessionAuthoringDataPanelModalMode != SessionAuthoringDataPanelModalComponent.Mode.None && this.state.Selected && this.state.Sessions && /*#__PURE__*/React.createElement(SessionAuthoringDataPanelModalComponent["default"], {
        mode: this.state.SessionAuthoringDataPanelModalMode,
        sessionId: this.state.Selected.SessionId,
        onBack: this.backAuthoringDataPanelModal.bind(this),
        onHidden: this.hiddenAuthoringDataPanelModal.bind(this)
      }), this.state.SessionGroupMaterialModalMode != SessionGroupMaterialModalComponent.Mode.None && this.state.Selected && this.state.Sessions && /*#__PURE__*/React.createElement(SessionGroupMaterialModalComponent["default"], {
        mode: this.state.SessionGroupMaterialModalMode,
        group: this.state.Selected.SelectedGroupMaterial,
        onEntry: this.entryGroupMaterial.bind(this),
        onModify: this.modifyGroupMaterial.bind(this),
        onDelete: this.deleteGroupMaterial.bind(this),
        onHidden: this.hiddenGroupMaterial.bind(this)
      }));
    }
  }]);

  return MainComponent;
}(React.Component);
/**
 * レンダラー
 *
 * @param el バインド対象
 * @param common 共通
 * @param queryRefreshInterval 検索リフレッシュインターバル
 * @param defaultCenterLatitude 地図 初期表示：中心：緯度
 * @param defaultCenterLongitude 地図 初期表示：中心：経度
 * @param defaultSelectLatitude 地図 初期選択座標：緯度
 * @param defaultSelectLongitude 地図 初期選択座標：経度
 * @param defaultSelectLevel 地図 初期表示範囲
 * @param defaultMapZoom 地図 初期倍率
 * @param rectDistance 地形 地図 Pinから矩形領域までの半径距離（km） 演算された円に接する矩形を表示する
 * @param sessionStorageSize １セッションが管理できる素材のトータルサイズ
 * @param avatarStorageSize アバターのサイズ
 * @param sessionId 会議ID
 * @param userId ユーザーID
 * @param mode モード
 * @param pageSize ページサイズ
 * @param defaultSceneModelName シーンのデフォルトモデル名
 * @param defaultSceneImageName シーンのデフォルトイメージ名
 * @param useOneDrive OneDriveを使用可能かどうか
 * @param clientId クライアントID
 * @param useLargeCapacityOption 大容量データオプション
 * @param useDataIntegrationOption データ連携オプション
 */


export default function (el, common, queryRefreshInterval, defaultCenterLatitude, defaultCenterLongitude, defaultSelectLatitude, defaultSelectLongitude, defaultSelectLevel, defaultMapZoom, rectDistance, sessionStorageSize, avatarStorageSize, sessionId, userId, mode, pageSize, defaultSceneModelName, defaultSceneImageName, useOneDrive, clientId, useLargeCapacityOption, useDataIntegrationOption) {
  ReactDOM.render( /*#__PURE__*/React.createElement(MainComponent, {
    common: common,
    queryRefreshInterval: queryRefreshInterval,
    defaultCenterLatitude: defaultCenterLatitude,
    defaultCenterLongitude: defaultCenterLongitude,
    defaultSelectLatitude: defaultSelectLatitude,
    defaultSelectLongitude: defaultSelectLongitude,
    defaultSelectLevel: defaultSelectLevel,
    defaultMapZoom: defaultMapZoom,
    rectDistance: rectDistance,
    sessionStorageSize: sessionStorageSize,
    AvatarStorageSize: avatarStorageSize,
    sessionId: sessionId,
    userId: userId,
    mode: mode,
    pageSize: pageSize,
    defaultSceneModelName: defaultSceneModelName,
    defaultSceneImageName: defaultSceneImageName,
    useOneDrive: useOneDrive,
    clientId: clientId,
    useLargeCapacityOption: useLargeCapacityOption,
    useDataIntegrationOption: useDataIntegrationOption
  }), el);
}